export const translations = {
    en: {
        app_title: "SSA Application",
        dashboard_subtitle: "Case Management Dashboard",
        new_assessment: "New Assessment",
        start_new_assessment: "Start New Assessment",
        assessment_number: "Assessment #",
        manage_case_workers: "Manage Case Workers",
        analytics: "Analytics",
        total_case_workers: "Total Case Workers",
        total_cases: "Total Cases",
        completed: "Completed",
        active_users: "Active Users",
        case_worker_activity: "Case Worker Activity",
        recent_assessments: "Recent Assessments",
        count_cases: "{count} cases",
        loading_cases: "Loading cases...",
        no_assessments: "No assessments yet",
        create_first: "Create your first assessment to get started",
        search_placeholder: "Search by client name or ID...",
        search_button: "Search",
        delete_assessment_title: "Delete Assessment?",
        delete_assessment_desc: "This action cannot be undone. This will permanently delete the assessment, recordings, transcript, and scores.",
        cancel: "Cancel",
        delete: "Delete",
        case_worker: "Case Worker",
        role: "Role",
        cases: "Cases",
        submitted: "Submitted",
        recordings: "Recordings",
        status_created: "Created",
        status_audio_uploaded: "Audio Ready",
        status_transcribed: "Transcribed",
        status_analyzed: "Analyzed",
        report_summary: "Summary",
        manage_case_worker_menu: "Case Worker Management",
        ai_settings_menu: "AI Settings",
        sign_out: "Sign Out",
        delete_assessment_tooltip: "Delete Assessment",
        assessment_deleted_toast: "Assessment deleted",
        failed_delete_assessment_toast: "Failed to delete assessment",

        // Login
        login_subtitle: "Sign in to access the assessment system",
        email_label: "Email",
        email_placeholder: "Enter your email",
        otp_code_label: "Verification Code",
        otp_code_placeholder: "Enter 6-digit code",
        verify_otp: "Verify Code",
        verifying_otp: "Verifying...",
        otp_sent_msg: "A verification code has been sent to your email.",
        enter_otp: "Please enter the verification code",
        back_to_login: "Back to Login",
        password_label: "Password",
        password_placeholder: "Enter your password",
        sign_in: "Sign In",
        signing_in: "Signing in...",
        enter_email_password: "Please enter email and password",
        welcome: "Welcome",
        invalid_credentials: "Invalid credentials",

        // Case Detail
        dashboard_breadcrumb: "Dashboard",
        case_information: "Case Information",
        assessment_date: "Assessment Date",
        next_step: "Next Step",
        view_transcript: "View Transcript",
        view_results: "View Results",
        view_full_results: "View Full Results",
        assessment_workflow: "Assessment Workflow",
        domain_scores_summary: "Domain Scores Summary",
        assessment_history: "Assessment History",
        track_progress: "Track progress across multiple assessments",
        current: "Current",
        view: "View",
        quick_actions: "Quick Actions",
        edit_case_details: "Edit Case Details",
        save_changes_btn: "Save Changes",
        saving: "Saving...",
        export_pdf: "Export PDF",
        view_transcript_desc: "Review the transcribed conversation",
        analyze_desc: "Analyze transcript against the Self-Sufficiency Matrix",
        view_results_desc: "Review and adjust domain scores",
        record_desc: "Start recording the assessment conversation",
        success_case_updated: "Case details updated",
        error_update_case: "Failed to update case details",
        transcript: "Transcript",
        results: "Results",


        // New Case
        new_assessment_title: "New Assessment",
        new_assessment_subtitle: "Create a new case for assessment",
        back: "Back",
        client_info_title: "Client Information",
        client_info_desc: "Enter the client details to begin the assessment",
        client_name_label: "Client Name",
        client_id_label: "Client ID",
        postal_code_label: "Postal Code",
        enter_name_placeholder: "Enter name",
        client_id_placeholder: "e.g., CLT-001",
        postal_code_placeholder: "e.g., 10001",
        client_id_help: "Unique identifier for this client (for privacy)",
        create_start_recording: "Create & Start Recording",
        creating: "Creating...",
        error_client_name_required: "Client name is required",
        error_client_id_required: "Client ID is required",
        error_postal_code_required: "Postal Code is required",
        success_case_created: "Case created successfully",
        error_create_case: "Failed to create case",

        // Recording
        record_conversation: "Record Conversation",
        microphone: "Microphone",
        select_device: "Select device",
        consent: "Consent",
        consent_confirmation: "I confirm consent has been obtained.",
        recorder: "Recorder",
        status_recording: "Recording...",
        status_paused: "Paused",
        status_saved: "Saved",
        status_ready: "Ready",
        click_to_start: "Click microphone to start",
        or: "OR",
        upload_audio: "Upload Audio File",
        upload_help: "MP3, WAV, M4A (Max 200MB)",
        preview: "Preview",
        discard: "Discard",
        process_recording: "Process Recording",
        status_uploading: "Uploading audio...",
        status_transcribing: "Transcribing...",
        uploaded_recordings: "Uploaded Recordings",
        deselect_all: "Deselect All",
        select_all: "Select All",
        transcribe_selected: "Transcribe Selected",
        save_recording_title: "Save Recording",
        save_recording_desc: "Give this recording a meaningful name to help you identify it later.",
        recording_name_label: "Recording Name",
        delete_recording_title: "Delete Recording?",
        delete_recording_desc: "Are you sure you want to permanently delete this recording? This action cannot be undone.",
        discard_recording_title: "Discard Recording?",
        discard_recording_desc: "This will remove the current unsaved recording. This action cannot be undone.",

        // Transcript
        review_edit_transcript: "Review & Edit Transcript",
        save_changes: "Save Changes",
        run_analysis: "Run Analysis",
        run_matrix_analysis: "Run Matrix Analysis",
        analyzing_status: "Analyzing...",
        no_transcript_title: "No transcript available",
        no_transcript_desc: "Record and transcribe a conversation first",
        go_to_recording: "Go to Recording",
        edit_transcript_title: "Edit Transcript",
        edit_transcript_desc: "Review and edit the transcript below. Correct any mistakes before running the analysis.",
        editable_text_label: "Editable Text",
        transcript_placeholder: "Transcript text...",
        about_matrix_analysis: "About Matrix Analysis",
        matrix_analysis_desc: "The AI will analyze this transcript against all 19 domains of the Self-Sufficiency Matrix. Each domain will receive a score from 1-5 based on evidence found in the conversation. You will be able to review and override any scores before finalizing.",
        analyzing_transcript_title: "Analyzing Transcript...",
        analyzing_transcript_desc: "Our AI is carefully reviewing the conversation across all 19 domains of the Self-Sufficiency Matrix.",
        estimated_time: "Estimated Time",
        time_estimate: "1-2 minutes",
        do_not_close: "Please do not close this window or navigate away.",
        save_before_analyzing: "Save changes before analyzing",
        run_analysis_tooltip: "Run Analysis",
        apparent_contradictions_title: "Detected Inconsistencies",
        apparent_contradictions_desc: "Information provided by the client that appears to conflict with other statements.",
        no_contradictions: "No inconsistencies detected.",
        add_contradiction: "Add Inconsistency",
        analysis_config_title: "Analysis Configuration",
        analysis_config_desc: "Choose the target language for the AI analysis and report generation.",
        target_language_label: "Target Language",
        select_language_placeholder: "Select target language",
        language_analysis_note: "The AI will generate scoring justifications and the full case report in the selected language.",
        start_analysis_btn: "Start Analysis",
        error_load_transcript: "Failed to load transcript",
        success_transcript_updated: "Transcript updated",
        error_save_transcript: "Failed to save transcript",
        success_analysis_complete: "Analysis complete",
        error_analysis_failed: "Analysis failed",
        needs_review: "Needs Review",
        reviewed: "Reviewed",
        goal_label: "Goal",
        ai_score_label: "AI Score",
        confidence_label: "Confidence",
        final_score_label: "Final",
        ai_justification_title: "AI Justification",
        no_justification: "No justification provided.",
        evidence_quotes_title: "Evidence Quotes",
        no_evidence: "No evidence quotes found.",
        show_score_definitions: "Show Score Definitions",
        review_adjust_title: "Review & Adjust",
        final_score_range_label: "Final Score (0-5)",
        select_score_placeholder: "Select score",
        score_0_desc: "0 - N/A or Insufficient Info",
        score_1_desc: "1 - In Crisis",
        score_2_desc: "2 - Vulnerable",
        score_3_desc: "3 - Safe",
        score_4_desc: "4 - Building Capacity",
        score_5_desc: "5 - Thriving",
        mark_as_goal: "Mark as participant goal",
        notes_label: "Notes",
        add_notes_placeholder: "Add assessment notes...",
        confirm_save: "Confirm & Save",
        assessment_submitted_locked: "Assessment submitted. Edits locked.",
        loading_report: "Loading report...",
        no_report_generated_title: "No Report Generated",
        no_report_generated_desc: "Generate a comprehensive case report including Subjective, Objective, Assessment, Plan (SOAP), Key Strengths, and Action Plan.",
        generating_report: "Generating AI Report...",
        generate_report_btn: "Generate Report",
        generated_on: "Generated on",
        at_time: "at",
        edit_report_btn: "Edit Report",
        download_pdf_btn: "Download PDF",
        revert_to_original: "Revert to Original",
        loading: "Loading...",
        case_not_found: "Case not found",
        describe_inconsistency: "Describe inconsistency...",
        no_summary: "No summary content.",
        subjective_title: "1. Subjective",
        subjective_subtitle: "Client's stated needs and perspective.",
        subjective_placeholder: "Enter subjective findings...",
        no_subjective: "No subjective content.",
        objective_title: "2. Objective",
        objective_subtitle: "Observable facts and assessment scores.",
        objective_placeholder: "Enter objective findings...",
        no_objective: "No objective content.",
        assessment_title: "3. Assessment",
        assessment_subtitle: "Professional analysis of situation.",
        assessment_placeholder: "Enter assessment analysis...",
        no_assessment: "No assessment content.",
        plan_title: "4. Plan",
        plan_subtitle: "Next steps and recommendations.",
        plan_placeholder: "Enter plan...",
        no_plan: "No plan content.",
        key_strengths_title: "Key Strengths",
        no_strengths: "No key strengths identified.",
        add_strength_btn: "Add Strength",
        action_plan_title: "Action Plan Targets",
        domain_label: "Domain",
        remove_btn: "Remove",
        domain_placeholder: "Domain (e.g. Housing)",
        goal_placeholder: "Specific goal...",
        no_action_plan: "No action plan items.",
        add_action_goal_btn: "Add Action Goal",
        assessment_scores_tab: "Assessment Scores",
        case_report_tab: "Case Report",
        require_review_msg: "domain(s) require review. You must confirm score or adjust them before submitting. (Highlighted in yellow below)",
        total_score_label: "Total Score",
        pending_review_label: "Pending Review",
        goals_set_label: "Goals Set",
        domain_scores_title: "Domain Scores",
        assessment_locked_msg: "Assessment is locked.",
        review_ai_scores_desc: "Review AI-generated scores and make adjustments.",
        submit_assessment_title: "Submit Assessment?",
        submit_assessment_desc: "Once submitted, this assessment will be locked and cannot be edited by regular users. Only administrators will be able to make changes after submission. Are you sure you want to proceed?",
        submitting: "Submitting...",
        submit_confirm_btn: "Yes, Submit",
        report_updated_success: "Report updated successfully",
        report_generated_success: "Report generated successfully",
        report_revert_success: "Reverted to original AI report",
        copy_success: "copied to clipboard",
        status_submitted: "Submitted",
        domain_housing: "Housing",
        domain_employment: "Employment",
        domain_income: "Income",
        domain_food: "Food",
        domain_child_care: "Child Care",
        domain_childrens_education: "Children's Education",
        domain_adult_education: "Adult Education",
        domain_health_care_coverage: "Health Care Coverage",
        domain_life_skills: "Life Skills",
        domain_family_social_relations: "Family/Social Relations",
        domain_mobility: "Mobility",
        domain_community_involvement: "Community Involvement",
        domain_parenting_skills: "Parenting Skills",
        domain_legal: "Legal",
        domain_mental_health: "Mental Health",
        domain_substance_abuse: "Substance Abuse",
        domain_safety: "Safety",
        domain_disabilities: "Disabilities",
        domain_other_optional: "Other (Optional)",
        enter_manual_transcript: "Upload Text Transcript",
        manual_transcript_desc: "Provide the text of the conversation. Our AI will securely process this transcript to evaluate the client against the Self-Sufficiency Matrix.",
        proceed: "Process Transcript",
        error_empty_transcript: "Transcript cannot be empty",
        success_transcript_saved: "Transcript saved successfully"
    },
    fr: {
        app_title: "Application SSA",
        dashboard_subtitle: "Tableau de bord de gestion des cas",
        new_assessment: "Nouvelle évaluation",
        manage_case_workers: "Gérer les travailleurs sociaux",
        analytics: "Analytique",
        total_case_workers: "Total des travailleurs sociaux",
        total_cases: "Total des cas",
        completed: "Terminé",
        active_users: "Utilisateurs actifs",
        case_worker_activity: "Activité du travailleur social",
        recent_assessments: "Évaluations récentes",
        count_cases: "{count} cas",
        loading_cases: "Chargement des cas...",
        no_assessments: "Aucune évaluation pour le moment",
        create_first: "Créez votre première évaluation pour commencer",
        search_placeholder: "Rechercher par nom de client ou ID...",
        search_button: "Rechercher",
        delete_assessment_title: "Supprimer l'évaluation ?",
        delete_assessment_desc: "Cette action est irréversible. Cela supprimera définitivement l'évaluation, les enregistrements, la transcription et les scores.",
        cancel: "Annuler",
        delete: "Supprimer",
        case_worker: "Travailleur social",
        role: "Rôle",
        cases: "Cas",
        submitted: "Soumis",
        recordings: "Enregistrements",
        status_created: "Créé",
        status_audio_uploaded: "Audio prêt",
        status_transcribed: "Transcrit",
        status_analyzed: "Analysé",
        report_summary: "Résumé",
        manage_case_worker_menu: "Gestion des travailleurs sociaux",
        ai_settings_menu: "Paramètres IA",
        sign_out: "Se déconnecter",
        delete_assessment_tooltip: "Supprimer l'évaluation",
        assessment_deleted_toast: "Évaluation supprimée",
        failed_delete_assessment_toast: "Échec de la suppression de l'évaluation",

        // Case Detail
        dashboard_breadcrumb: "Tableau de bord",
        case_information: "Informations sur le cas",
        assessment_date: "Date d'évaluation",
        next_step: "Étape suivante",
        view_transcript: "Voir la transcription",
        view_results: "Voir les résultats",
        view_full_results: "Voir les résultats complets",
        assessment_workflow: "Flux de travail de l'évaluation",
        domain_scores_summary: "Résumé des scores par domaine",
        assessment_history: "Historique de l'évaluation",
        track_progress: "Suivre les progrès à travers plusieurs évaluations",
        current: "Actuel",
        view: "Voir",
        quick_actions: "Actions rapides",
        edit_case_details: "Modifier les détails du cas",
        save_changes_btn: "Sauvegarder les modifications",
        saving: "Sauvegarde...",
        export_pdf: "Exporter en PDF",
        view_transcript_desc: "Revoir la conversation transcrite",
        analyze_desc: "Analyser la transcription par rapport à la matrice d'autosuffisance",
        view_results_desc: "Revoir et ajuster les scores du domaine",
        record_desc: "Commencer l'enregistrement de la conversation d'évaluation",
        success_case_updated: "Détails du cas mis à jour",
        error_update_case: "Échec de la mise à jour des détails du cas",
        transcript: "Transcription",
        results: "Résultats",

        // New Case
        new_assessment_title: "Nouvelle évaluation",
        new_assessment_subtitle: "Créer un nouveau cas pour évaluation",
        back: "Retour",
        client_info_title: "Informations client",
        client_info_desc: "Entrez les détails du client pour commencer l'évaluation",
        client_name_label: "Nom du client",
        client_id_label: "ID client",
        postal_code_label: "Code postal",
        enter_name_placeholder: "Entrer le nom",
        client_id_placeholder: "ex. CLT-001",
        postal_code_placeholder: "ex. 10001",
        client_id_help: "Identifiant unique pour ce client (pour la confidentialité)",
        create_start_recording: "Créer et commencer l'enregistrement",
        creating: "Création...",
        error_client_name_required: "Le nom du client est requis",
        error_client_id_required: "L'ID client est requis",
        error_postal_code_required: "Le code postal est requis",
        success_case_created: "Cas créé avec succès",
        error_create_case: "Échec de la création du cas",

        // Recording
        record_conversation: "Enregistrer la conversation",
        microphone: "Microphone",
        select_device: "Sélectionner un appareil",
        consent: "Consentement",
        consent_confirmation: "Je confirme que le consentement a été obtenu.",
        recorder: "Enregistreur",
        status_recording: "Enregistrement...",
        status_paused: "En pause",
        status_saved: "Sauvegardé",
        status_ready: "Prêt",
        click_to_start: "Cliquez sur le micro pour commencer",
        or: "OU",
        upload_audio: "Télécharger un fichier audio",
        upload_help: "MP3, WAV, M4A (Max 200MB)",
        preview: "Aperçu",
        discard: "Rejeter",
        process_recording: "Traiter l'enregistrement",
        status_uploading: "Téléchargement audio...",
        status_transcribing: "Transcription...",
        uploaded_recordings: "Enregistrements téléchargés",
        deselect_all: "Tout désélectionner",
        select_all: "Tout sélectionner",
        transcribe_selected: "Transcrire la sélection",
        save_recording_title: "Sauvegarder l'enregistrement",
        save_recording_desc: "Donnez un nom significatif à cet enregistrement pour l'identifier plus tard.",
        recording_name_label: "Nom de l'enregistrement",
        delete_recording_title: "Supprimer l'enregistrement ?",
        delete_recording_desc: "Êtes-vous sûr de vouloir supprimer définitivement cet enregistrement ? Cette action est irréversible.",
        discard_recording_title: "Rejeter l'enregistrement ?",
        discard_recording_desc: "Cela supprimera l'enregistrement non sauvegardé actuel. Cette action est irréversible.",

        // Transcript
        review_edit_transcript: "Revoir et modifier la transcription",
        save_changes: "Sauvegarder les modifications",
        run_analysis: "Lancer l'analyse",
        run_matrix_analysis: "Lancer l'analyse matricielle",
        analyzing_status: "Analyse en cours...",
        no_transcript_title: "Aucune transcription disponible",
        no_transcript_desc: "Enregistrez et transcrivez d'abord une conversation",
        go_to_recording: "Aller à l'enregistrement",
        edit_transcript_title: "Modifier la transcription",
        edit_transcript_desc: "Revoyez et modifiez la transcription ci-dessous. Corrigez les erreurs avant de lancer l'analyse.",
        editable_text_label: "Texte modifiable",
        transcript_placeholder: "Texte de la transcription...",
        about_matrix_analysis: "À propos de l'analyse matricielle",
        matrix_analysis_desc: "L'IA analysera cette transcription par rapport aux 19 domaines de la matrice d'autosuffisance. Chaque domaine recevra un score de 1 à 5 basé sur les preuves trouvées dans la conversation. Vous pourrez revoir et modifier les scores avant de finaliser.",
        analyzing_transcript_title: "Analyse de la transcription...",
        analyzing_transcript_desc: "Notre IA examine attentivement la conversation à travers les 19 domaines de la matrice d'autosuffisance.",
        estimated_time: "Temps estimé",
        time_estimate: "1-2 minutes",
        do_not_close: "Veuillez ne pas fermer cette fenêtre ou naviguer ailleurs.",
        save_before_analyzing: "Enregistrez les modifications avant l'analyse",
        run_analysis_tooltip: "Lancer l'analyse",
        apparent_contradictions_title: "Incohérences détectées",
        apparent_contradictions_desc: "Informations fournies par le client qui semblent entrer en conflit avec d'autres déclarations.",
        no_contradictions: "Aucune incohérence détectée.",
        add_contradiction: "Ajouter une incohérence",
        analysis_config_title: "Configuration de l'analyse",
        analysis_config_desc: "Choisissez la langue cible pour l'analyse IA et la génération de rapports.",
        target_language_label: "Langue cible",
        select_language_placeholder: "Sélectionnez la langue cible",
        language_analysis_note: "L'IA générera les justifications de score et le rapport de cas complet dans la langue sélectionnée.",
        start_analysis_btn: "Lancer l'analyse",
        error_load_transcript: "Échec du chargement de la transcription",
        success_transcript_updated: "Transcription mise à jour",
        error_save_transcript: "Échec de l'enregistrement de la transcription",
        success_analysis_complete: "Analyse terminée",
        error_analysis_failed: "L'analyse a échoué",
        needs_review: "Révision nécessaire",
        reviewed: "Révisé",
        goal_label: "Objectif",
        ai_score_label: "Score IA",
        confidence_label: "Confiance",
        final_score_label: "Final",
        ai_justification_title: "Justification IA",
        no_justification: "Aucune justification fournie.",
        evidence_quotes_title: "Citations de preuves",
        no_evidence: "Aucune citation trouvée.",
        show_score_definitions: "Afficher les définitions",
        review_adjust_title: "Révision & Ajustement",
        final_score_range_label: "Score final (0-5)",
        select_score_placeholder: "Choisir un score",
        score_0_desc: "0 - N/A ou Info insuffisante",
        score_1_desc: "1 - En crise",
        score_2_desc: "2 - Vulnérable",
        score_3_desc: "3 - Stable",
        score_4_desc: "4 - En construction",
        score_5_desc: "5 - Épanoui",
        mark_as_goal: "Marquer comme objectif du participant",
        notes_label: "Notes",
        add_notes_placeholder: "Ajouter des notes...",
        confirm_save: "Confirmer & Enregistrer",
        assessment_submitted_locked: "Évaluation soumise. Modifications verrouillées.",
        loading_report: "Chargement du rapport...",
        no_report_generated_title: "Aucun rapport généré",
        no_report_generated_desc: "Générez un rapport de cas complet comprenant le Subjectif, l'Objectif, l'Évaluation, le Plan (SOAP), les forces clés et le plan d'action.",
        generating_report: "Génération du rapport IA...",
        generate_report_btn: "Générer le rapport",
        generated_on: "Généré le",
        at_time: "à",
        edit_report_btn: "Modifier le rapport",
        download_pdf_btn: "Télécharger PDF",
        revert_to_original: "Revenir à l'original",
        loading: "Chargement...",
        case_not_found: "Cas non trouvé",
        describe_inconsistency: "Décrire l'incohérence...",
        no_summary: "Aucun contenu de résumé.",
        subjective_title: "1. Subjectif",
        subjective_subtitle: "Besoins et perspectives du client.",
        subjective_placeholder: "Entrer les conclusions subjectives...",
        no_subjective: "Aucun contenu subjectif.",
        objective_title: "2. Objectif",
        objective_subtitle: "Faits observables et scores d'évaluation.",
        objective_placeholder: "Entrer les conclusions objectives...",
        no_objective: "Aucun contenu objectif.",
        assessment_title: "3. Évaluation",
        assessment_subtitle: "Analyse professionnelle de la situation.",
        assessment_placeholder: "Entrer l'analyse...",
        no_assessment: "Aucun contenu d'évaluation.",
        plan_title: "4. Plan",
        plan_subtitle: "Prochaines étapes et recommandations.",
        plan_placeholder: "Entrer le plan...",
        no_plan: "Aucun contenu de plan.",
        key_strengths_title: "Forces clés",
        no_strengths: "Aucune force identifiée.",
        add_strength_btn: "Ajouter une force",
        action_plan_title: "Objectifs du plan d'action",
        domain_label: "Domaine",
        remove_btn: "Supprimer",
        domain_placeholder: "Domaine (ex. Logement)",
        goal_placeholder: "Objectif spécifique...",
        no_action_plan: "Aucun élément de plan d'action.",
        add_action_goal_btn: "Ajouter un objectif",
        assessment_scores_tab: "Scores d'évaluation",
        case_report_tab: "Rapport de cas",
        require_review_msg: "domaine(s) nécessite(nt) une révision. Confirmez le score ou ajustez-les avant de soumettre.",
        total_score_label: "Score total",
        pending_review_label: "En attente de révision",
        goals_set_label: "Objectifs fixés",
        domain_scores_title: "Scores des domaines",
        assessment_locked_msg: "L'évaluation est verrouillée.",
        review_ai_scores_desc: "Révisez les scores générés par l'IA et effectuez des ajustements.",
        submit_assessment_title: "Soumettre l'évaluation ?",
        submit_assessment_desc: "Une fois soumise, cette évaluation sera verrouillée. Seuls les administrateurs pourront la modifier. Voulez-vous continuer ?",
        submitting: "Soumission...",
        submit_confirm_btn: "Oui, soumettre",
        status_submitted: "Soumis",
        domain_housing: "Logement",
        domain_employment: "Emploi",
        domain_income: "Revenu",
        domain_food: "Alimentation",
        domain_child_care: "Garde d'enfants",
        domain_childrens_education: "Éducation des enfants",
        domain_adult_education: "Éducation des adultes",
        domain_health_care_coverage: "Couverture santé",
        domain_life_skills: "Compétences de vie",
        domain_family_social_relations: "Relations familiales/sociales",
        domain_mobility: "Mobilité",
        domain_community_involvement: "Implication communautaire",
        domain_parenting_skills: "Compétences parentales",
        domain_legal: "Juridique",
        domain_mental_health: "Santé mentale",
        domain_substance_abuse: "Toxicomanie",
        domain_safety: "Sécurité",
        domain_disabilities: "Handicaps",
        domain_other_optional: "Autre (Optionnel)"
    },
    es: {
        app_title: "Aplicación SSA",
        dashboard_subtitle: "Panel de Gestión de Casos",
        new_assessment: "Nueva Evaluación",
        manage_case_workers: "Administrar Trabajadores Sociales",
        analytics: "Analítica",
        total_case_workers: "Total de Trabajadores Sociales",
        total_cases: "Total de Casos",
        completed: "Completado",
        active_users: "Usuarios Activos",
        case_worker_activity: "Actividad del Trabajador Social",
        recent_assessments: "Evaluaciones Recientes",
        count_cases: "{count} casos",
        loading_cases: "Cargando casos...",
        no_assessments: "Aún no hay evaluaciones",
        create_first: "Crea tu primera evaluación para comenzar",
        search_placeholder: "Buscar por nombre de cliente o ID...",
        search_button: "Buscar",
        delete_assessment_title: "¿Eliminar evaluación?",
        delete_assessment_desc: "Esta acción no se puede deshacer. Esto eliminará permanentemente la evaluación, las grabaciones, la transcripción y las puntuaciones.",
        cancel: "Cancelar",
        delete: "Eliminar",
        case_worker: "Trabajador Social",
        role: "Rol",
        cases: "Casos",
        submitted: "Enviado",
        recordings: "Grabaciones",
        status_created: "Creado",
        status_audio_uploaded: "Audio Listo",
        status_transcribed: "Transcrito",
        status_analyzed: "Analizado",
        report_summary: "Resumen",
        manage_case_worker_menu: "Gestión de Trabajadores Sociales",
        ai_settings_menu: "Configuración de IA",
        sign_out: "Cerrar Sesión",
        delete_assessment_tooltip: "Eliminar Evaluación",
        assessment_deleted_toast: "Evaluación eliminada",
        failed_delete_assessment_toast: "Error al eliminar la evaluación",

        // Case Detail
        dashboard_breadcrumb: "Panel",
        case_information: "Información del Caso",
        assessment_date: "Fecha de Evaluación",
        next_step: "Siguiente Paso",
        view_transcript: "Ver Transcripción",
        view_results: "Ver Resultados",
        view_full_results: "Ver Resultados Completos",
        assessment_workflow: "Flujo de Trabajo",
        domain_scores_summary: "Resumen de Puntuaciones",
        assessment_history: "Historial de Evaluación",
        track_progress: "Seguimiento del progreso",
        current: "Actual",
        view: "Ver",
        quick_actions: "Acciones Rápidas",
        edit_case_details: "Editar Detalles del Caso",
        save_changes_btn: "Guardar Cambios",
        saving: "Guardando...",
        export_pdf: "Exportar PDF",
        view_transcript_desc: "Revisar la conversación transcrita",
        analyze_desc: "Analizar transcripción con la Matriz de Autosuficiencia",
        view_results_desc: "Revisar y ajustar puntuaciones de dominio",
        record_desc: "Comenzar a grabar la conversación de evaluación",
        success_case_updated: "Detalles del caso actualizados",
        error_update_case: "Error al actualizar los detalles del caso",
        transcript: "Transcripción",
        results: "Resultados",

        // New Case
        new_assessment_title: "Nueva Evaluación",
        new_assessment_subtitle: "Crear un nuevo caso para evaluación",
        back: "Atrás",
        client_info_title: "Información del Cliente",
        client_info_desc: "Ingrese los detalles del cliente para comenzar la evaluación",
        client_name_label: "Nombre del Cliente",
        client_id_label: "ID del Cliente",
        postal_code_label: "Código Postal",
        enter_name_placeholder: "Ingresar nombre",
        client_id_placeholder: "ej. CLT-001",
        postal_code_placeholder: "ej. 10001",
        client_id_help: "Identificador único para este cliente (por privacidad)",
        create_start_recording: "Crear y comenzar a grabar",
        creating: "Creando...",
        error_client_name_required: "El nombre del cliente es obligatorio",
        error_client_id_required: "El ID del cliente es obligatorio",
        error_postal_code_required: "El código postal es obligatorio",
        success_case_created: "Caso creado exitosamente",
        error_create_case: "Error al crear el caso",

        // Recording
        record_conversation: "Grabar Conversación",
        microphone: "Micrófono",
        select_device: "Seleccionar dispositivo",
        consent: "Consentimiento",
        consent_confirmation: "Confirmo que se ha obtenido el consentimiento.",
        recorder: "Grabadora",
        status_recording: "Grabando...",
        status_paused: "Pausado",
        status_saved: "Guardado",
        status_ready: "Listo",
        click_to_start: "Haga clic en el micrófono para comenzar",
        or: "O",
        upload_audio: "Subir archivo de audio",
        upload_help: "MP3, WAV, M4A (Max 200MB)",
        preview: "Vista previa",
        discard: "Descartar",
        process_recording: "Procesar Grabación",
        status_uploading: "Subiendo audio...",
        status_transcribing: "Transcribiendo...",
        uploaded_recordings: "Grabaciones Subidas",
        deselect_all: "Deseleccionar todo",
        select_all: "Seleccionar todo",
        transcribe_selected: "Transcribir seleccionados",
        save_recording_title: "Guardar Grabación",
        save_recording_desc: "Dé un nombre significativo a esta grabación para identificarla más tarde.",
        recording_name_label: "Nombre de la Grabación",
        delete_recording_title: "¿Eliminar Grabación?",
        delete_recording_desc: "¿Está seguro de que desea eliminar permanentemente esta grabación? Esta acción no se puede deshacer.",
        discard_recording_title: "¿Descartar Grabación?",
        discard_recording_desc: "Esto eliminará la grabación actual no guardada. Esta acción no se puede deshacer.",

        // Transcript
        review_edit_transcript: "Revisar y Editar Transcripción",
        save_changes: "Guardar Cambios",
        run_analysis: "Ejecutar Análisis",
        run_matrix_analysis: "Ejecutar Análisis de Matriz",
        analyzing_status: "Analizando...",
        no_transcript_title: "No hay transcripción disponible",
        no_transcript_desc: "Grabe y transcriba una conversación primero",
        go_to_recording: "Ir a Grabación",
        edit_transcript_title: "Editar Transcripción",
        edit_transcript_desc: "Revise y edite la transcripción a continuación. Corrija cualquier error antes de ejecutar el análisis.",
        editable_text_label: "Texto Editable",
        transcript_placeholder: "Texto de la transcripción...",
        about_matrix_analysis: "Acerca del Análisis de Matriz",
        matrix_analysis_desc: "La IA analizará esta transcripción contra los 19 dominios de la Matriz de Autosuficiencia. Cada dominio recibirá una puntuación de 1 a 5 basada en la evidencia encontrada en la conversación. Podrá revisar y anular cualquier puntuación antes de finalizar.",
        analyzing_transcript_title: "Analizando Transcripción...",
        analyzing_transcript_desc: "Nuestra IA está revisando cuidadosamente la conversación en los 19 dominios de la Matriz de Autosuficiencia.",
        estimated_time: "Tiempo Estimado",
        time_estimate: "1-2 minutos",
        do_not_close: "Por favor, no cierre esta ventana ni navegue fuera de ella.",
        save_before_analyzing: "Guarde los cambios antes de analizar",
        run_analysis_tooltip: "Ejecutar Análisis",
        apparent_contradictions_title: "Inconsistencias Detectadas",
        apparent_contradictions_desc: "Información proporcionada por el cliente que parece entrar en conflicto con otras declaraciones.",
        no_contradictions: "No se detectaron inconsistencias.",
        add_contradiction: "Agregar Inconsistencia",
        analysis_config_title: "Configuración del Análisis",
        analysis_config_desc: "Elija el idioma de destino para el análisis de IA y la generación de informes.",
        target_language_label: "Idioma de Destino",
        select_language_placeholder: "Seleccione el idioma de destino",
        language_analysis_note: "La IA generará justificaciones de puntuación y el informe de caso completo en el idioma seleccionado.",
        start_analysis_btn: "Iniciar Análisis",
        error_load_transcript: "Error al cargar la transcripción",
        success_transcript_updated: "Transcripción actualizada",
        error_save_transcript: "Error al guardar la transcripción",
        success_analysis_complete: "Analyse complète",
        error_analysis_failed: "El análisis falló",
        needs_review: "Necesita Revisión",
        reviewed: "Revisado",
        goal_label: "Meta",
        ai_score_label: "Puntaje IA",
        confidence_label: "Confianza",
        final_score_label: "Final",
        ai_justification_title: "Justificación de la IA",
        no_justification: "No se proporcionó justificación.",
        evidence_quotes_title: "Citas de Evidencia",
        no_evidence: "No se encontraron citas de evidencia.",
        show_score_definitions: "Mostrar Definiciones",
        review_adjust_title: "Revisar y Ajustar",
        final_score_range_label: "Puntaje Final (0-5)",
        select_score_placeholder: "Seleccionar puntaje",
        score_0_desc: "0 - N/A o Info Insuficiente",
        score_1_desc: "1 - En Crisis",
        score_2_desc: "2 - Vulnerable",
        score_3_desc: "3 - Seguro",
        score_4_desc: "4 - Construyendo Capacidad",
        score_5_desc: "5 - Prosperando",
        mark_as_goal: "Marcar como meta del participante",
        notes_label: "Notas",
        add_notes_placeholder: "Agregar notas de evaluación...",
        confirm_save: "Confirmar y Guardar",
        assessment_submitted_locked: "Evaluación enviada. Ediciones bloqueadas.",
        loading_report: "Cargando informe...",
        no_report_generated_title: "No se ha generado ningún informe",
        no_report_generated_desc: "Generar un informe de caso completo que incluya Subjetivo, Objetivo, Evaluación, Plan (SOAP), Fortalezas Clave y Plan de Acción.",
        generating_report: "Generando Informe de IA...",
        generate_report_btn: "Generar Informe",
        generated_on: "Generado el",
        at_time: "a las",
        edit_report_btn: "Editar Informe",
        download_pdf_btn: "Descargar PDF",
        revert_to_original: "Revertir al Original",
        loading: "Cargando...",
        case_not_found: "Caso no encontrado",
        describe_inconsistency: "Describir inconsistencia...",
        no_summary: "Sin contenido de resumen.",
        subjective_title: "1. Subjetivo",
        subjective_subtitle: "Necesidades y perspectiva declaradas del cliente.",
        subjective_placeholder: "Ingrese hallazgos subjetivos...",
        no_subjective: "Sin contenido subjetivo.",
        objective_title: "2. Objetivo",
        objective_subtitle: "Hechos observables y puntajes de evaluación.",
        objective_placeholder: "Ingrese hallazgos objetivos...",
        no_objective: "Sin contenido objetivo.",
        assessment_title: "3. Evaluación",
        assessment_subtitle: "Análisis profesional de la situación.",
        assessment_placeholder: "Ingrese análisis de evaluación...",
        no_assessment: "Sin contenido de evaluación.",
        plan_title: "4. Plan",
        plan_subtitle: "Próximos pasos y recomendaciones.",
        plan_placeholder: "Ingrese el plan...",
        no_plan: "Sin contenido de plan.",
        key_strengths_title: "Fortalezas Clave",
        no_strengths: "No se identificaron fortalezas clave.",
        add_strength_btn: "Agregar Fortaleza",
        action_plan_title: "Objetivos del Plan de Acción",
        domain_label: "Dominio",
        remove_btn: "Eliminar",
        domain_placeholder: "Dominio (ej. Vivienda)",
        goal_placeholder: "Meta específica...",
        no_action_plan: "Sin elementos en el plan de acción.",
        add_action_goal_btn: "Agregar Meta de Acción",
        assessment_scores_tab: "Puntajes de Evaluación",
        case_report_tab: "Informe de Caso",
        require_review_msg: "dominio(s) requieren revisión. Debe confirmar el puntaje o ajustarlos antes de enviar.",
        total_score_label: "Puntaje Total",
        pending_review_label: "Revisión Pendiente",
        goals_set_label: "Metas Establecidas",
        domain_scores_title: "Puntajes de Dominio",
        assessment_locked_msg: "La evaluación está bloqueada.",
        review_ai_scores_desc: "Revise los puntajes generados por la IA y realice ajustes.",
        submit_assessment_title: "¿Enviar Evaluación?",
        submit_assessment_desc: "Una vez enviada, esta evaluación se bloqueará y no podrá ser editada por usuarios regulares. ¿Está seguro de que desea proceder?",
        submitting: "Enviando...",
        submit_confirm_btn: "Sí, Enviar",
        status_submitted: "Enviado",
        domain_housing: "Vivienda",
        domain_employment: "Empleo",
        domain_income: "Ingresos",
        domain_food: "Alimentación",
        domain_child_care: "Cuidado de Niños",
        domain_childrens_education: "Educación de los Niños",
        domain_adult_education: "Educación de Adultos",
        domain_health_care_coverage: "Cobertura de Salud",
        domain_life_skills: "Habilidades para la Vida",
        domain_family_social_relations: "Relaciones Familiares/Sociales",
        domain_mobility: "Movilidad",
        domain_community_involvement: "Participación Comunitaria",
        domain_parenting_skills: "Habilidades Parentales",
        domain_legal: "Legal",
        domain_mental_health: "Salud Mental",
        domain_substance_abuse: "Abuso de Sustancias",
        domain_safety: "Seguridad",
        domain_disabilities: "Discapacidades",
        domain_other_optional: "Otro (Opcional)"
    },
    zh: {
        app_title: "SSA 应用程序",
        dashboard_subtitle: "个案管理仪表板",
        new_assessment: "新评估",
        manage_case_workers: "管理个案工作者",
        analytics: "分析",
        total_case_workers: "个案工作者总数",
        total_cases: "个案总数",
        completed: "已完成",
        active_users: "活跃用户",
        case_worker_activity: "个案工作者活动",
        recent_assessments: "最近评估",
        count_cases: "{count} 个案",
        loading_cases: "正在加载个案...",
        no_assessments: "暂无评估",
        create_first: "创建您的第一个评估以开始",
        search_placeholder: "按客户姓名或 ID 搜索...",
        search_button: "搜索",
        delete_assessment_title: "删除评估？",
        delete_assessment_desc: "此操作无法撤销。这将永久删除评估、录音、成绩单和分数。",
        cancel: "取消",
        delete: "删除",
        case_worker: "个案工作者",
        role: "角色",
        cases: "个案",
        submitted: "已提交",
        recordings: "录音",
        status_created: "已创建",
        status_audio_uploaded: "音频就绪",
        status_transcribed: "已转录",
        status_analyzed: "已分析",
        report_summary: "摘要",
        manage_case_worker_menu: "个案工作者管理",
        ai_settings_menu: "AI 设置",
        sign_out: "退出",
        delete_assessment_tooltip: "删除评估",
        assessment_deleted_toast: "评估已删除",
        failed_delete_assessment_toast: "删除评估失败",

        // Case Detail
        dashboard_breadcrumb: "仪表板",
        case_information: "个案信息",
        assessment_date: "评估日期",
        next_step: "下一步",
        view_transcript: "查看成绩单",
        view_results: "查看结果",
        view_full_results: "查看完整结果",
        assessment_workflow: "评估工作流程",
        domain_scores_summary: "领域得分摘要",
        assessment_history: "评估历史",
        track_progress: "跟踪多个评估的进度",
        current: "当前",
        view: "查看",
        quick_actions: "快速操作",
        edit_case_details: "编辑个案详情",
        save_changes_btn: "保存更改",
        saving: "正在保存...",
        export_pdf: "导出 PDF",
        view_transcript_desc: "查看已转录的对话",
        analyze_desc: "根据自给自足矩阵分析成绩单",
        view_results_desc: "查看并调整领域得分",
        record_desc: "开始录制评估对话",
        success_case_updated: "个案详情已更新",
        error_update_case: "更新个案详情失败",
        transcript: "成绩单",
        results: "结果",

        // New Case
        new_assessment_title: "新评估",
        new_assessment_subtitle: "创建一个新个案进行评估",
        back: "返回",
        client_info_title: "客户信息",
        client_info_desc: "输入客户详细信息以开始评估",
        client_name_label: "客户姓名",
        client_id_label: "客户 ID",
        postal_code_label: "邮政编码",
        enter_name_placeholder: "输入姓名",
        client_id_placeholder: "例如 CLT-001",
        postal_code_placeholder: "例如 10001",
        client_id_help: "此客户的唯一标识符（用于隐私）",
        create_start_recording: "创建并开始录音",
        creating: "正在创建...",
        error_client_name_required: "客户姓名是必填项",
        error_client_id_required: "客户 ID 是必填项",
        error_postal_code_required: "邮政编码是必填项",
        success_case_created: "个案创建成功",
        error_create_case: "创建个案失败",

        // Recording
        record_conversation: "录制对话",
        microphone: "麦克风",
        select_device: "选择设备",
        consent: "同意",
        consent_confirmation: "我确认已获得同意。",
        recorder: "录音机",
        status_recording: "正在录音...",
        status_paused: "已暂停",
        status_saved: "已保存",
        status_ready: "就绪",
        click_to_start: "点击麦克风开始",
        or: "或",
        upload_audio: "上传音频文件",
        upload_help: "MP3, WAV, M4A (最大 200MB)",
        preview: "预览",
        discard: "放弃",
        process_recording: "处理录音",
        status_uploading: "正在上传音频...",
        status_transcribing: "正在转录...",
        uploaded_recordings: "已上传的录音",
        deselect_all: "取消全选",
        select_all: "全选",
        transcribe_selected: "转录选中项",
        save_recording_title: "保存录音",
        save_recording_desc: "给这个录音起一个有意义的名字，以便稍后识别。",
        recording_name_label: "录音名称",
        delete_recording_title: "删除录音？",
        delete_recording_desc: "您确定要永久删除此录音吗？此操作无法撤销。",
        discard_recording_title: "放弃录音？",
        discard_recording_desc: "这将删除当前未保存的录音。此操作无法撤销。",

        // Transcript
        review_edit_transcript: "查看和编辑成绩单",
        save_changes: "保存更改",
        run_analysis: "运行分析",
        run_matrix_analysis: "运行矩阵分析",
        analyzing_status: "正在分析...",
        no_transcript_title: "无可用成绩单",
        no_transcript_desc: "请先录制并转录对话",
        go_to_recording: "转到录音",
        edit_transcript_title: "编辑成绩单",
        edit_transcript_desc: "在下方查看和编辑成绩单。在运行分析之前更正任何错误。",
        editable_text_label: "可编辑文本",
        transcript_placeholder: "成绩单文本...",
        about_matrix_analysis: "关于矩阵分析",
        matrix_analysis_desc: "AI 将根据自给自足矩阵的所有 19 个领域分析此成绩单。每个领域将根据对话中的证据获得 1-5 分。您可以在定稿前查看并覆盖任何分数。",
        analyzing_transcript_title: "正在分析成绩单...",
        analyzing_transcript_desc: "我们的 AI 正在仔细审查自给自足矩阵所有 19 个领域的对话。",
        estimated_time: "预计时间",
        time_estimate: "1-2 分钟",
        do_not_close: "请勿关闭此窗口或离开。",
        save_before_analyzing: "分析前保存更改",
        run_analysis_tooltip: "运行分析",
        apparent_contradictions_title: "检测到的不一致",
        apparent_contradictions_desc: "客户提供的信息似乎与其他陈述相冲突。",
        no_contradictions: "未检测到不一致。",
        add_contradiction: "添加不一致",
        analysis_config_title: "分析配置",
        analysis_config_desc: "选择 AI 分析和报告生成的目标语言。",
        target_language_label: "目标语言",
        select_language_placeholder: "选择目标语言",
        language_analysis_note: "AI 将以所选语言生成评分依据和完整的个案报告。",
        start_analysis_btn: "开始分析",
        error_load_transcript: "无法加载转录",
        success_transcript_updated: "转录已更新",
        error_save_transcript: "无法保存转录",
        success_analysis_complete: "分析完成",
        error_analysis_failed: "分析失败",
        needs_review: "需要复核",
        reviewed: "已复核",
        goal_label: "目标",
        ai_score_label: "AI 评分",
        confidence_label: "置信度",
        final_score_label: "最终",
        ai_justification_title: "AI 理由",
        no_justification: "未提供理由。",
        evidence_quotes_title: "证据引用",
        no_evidence: "未找到证据引用。",
        show_score_definitions: "显示评分定义",
        review_adjust_title: "复核与调整",
        final_score_range_label: "最终评分 (0-5)",
        select_score_placeholder: "选择评分",
        score_0_desc: "0 - 不适用或信息不足",
        score_1_desc: "1 - 处于危机中",
        score_2_desc: "2 - 易受伤害",
        score_3_desc: "3 - 安全",
        score_4_desc: "4 - 建立能力",
        score_5_desc: "5 - 蓬勃发展",
        mark_as_goal: "标记为参与者目标",
        notes_label: "备注",
        add_notes_placeholder: "添加评估备注...",
        confirm_save: "确认并保存",
        assessment_submitted_locked: "评估已提交。编辑已锁定。",
        loading_report: "正在加载报告...",
        no_report_generated_title: "未生成报告",
        no_report_generated_desc: "生成一份完整的案例报告，包括主观 (S)、客观 (O)、评估 (A)、计划 (P) (SOAP)、关键优势和行动计划。",
        generating_report: "正在生成 AI 报告...",
        generate_report_btn: "生成报告",
        generated_on: "生成于",
        at_time: "在",
        edit_report_btn: "编辑报告",
        download_pdf_btn: "下载 PDF",
        revert_to_original: "恢复为原始版本",
        loading: "正在加载...",
        case_not_found: "找不到案例",
        describe_inconsistency: "描述不一致之处...",
        no_summary: "无摘要内容。",
        subjective_title: "1. 主观",
        subjective_subtitle: "客户自述的需求和观点。",
        subjective_placeholder: "输入主观调查结果...",
        no_subjective: "无主观内容。",
        objective_title: "2. 客观",
        objective_subtitle: "可观察的事实和评估分数。",
        objective_placeholder: "输入客观调查结果...",
        no_objective: "无客观内容。",
        assessment_title: "3. 评估",
        assessment_subtitle: "对情况的专业分析。",
        assessment_placeholder: "输入评估分析...",
        no_assessment: "无评估内容。",
        plan_title: "4. 计划",
        plan_subtitle: "后续步骤和建议。",
        plan_placeholder: "输入计划...",
        no_plan: "无计划内容。",
        key_strengths_title: "关键优势",
        no_strengths: "未识别出关键优势。",
        add_strength_btn: "添加优势",
        action_plan_title: "行动计划目标",
        domain_label: "领域",
        remove_btn: "移除",
        domain_placeholder: "领域（如：住房）",
        goal_placeholder: "具体目标...",
        no_action_plan: "无行动计划项目。",
        add_action_goal_btn: "添加行动目标",
        assessment_scores_tab: "评估分数",
        case_report_tab: "案例报告",
        require_review_msg: "个领域需要复核。您必须在提交前确认分数或进行调整。（下方以黄色突出显示）",
        total_score_label: "总分",
        pending_review_label: "待复核",
        goals_set_label: "已设目标",
        domain_scores_title: "领域分数",
        assessment_locked_msg: "评估已锁定。",
        review_ai_scores_desc: "复核 AI 生成的分数并进行调整。",
        submit_assessment_title: "提交评估？",
        submit_assessment_desc: "提交后，此评估将被锁定，普通用户无法编辑。只有管理员才能在提交后进行更改。您确定要继续吗？",
        submitting: "正在提交...",
        submit_confirm_btn: "是的，提交",
        status_submitted: "已提交",
        domain_housing: "住房",
        domain_employment: "就业",
        domain_income: "收入",
        domain_food: "食物",
        domain_child_care: "儿童看护",
        domain_childrens_education: "儿童教育",
        domain_adult_education: "成人教育",
        domain_health_care_coverage: "医疗保健覆盖",
        domain_life_skills: "生活技能",
        domain_family_social_relations: "家庭/社会关系",
        domain_mobility: "流动性",
        domain_community_involvement: "社区参与",
        domain_parenting_skills: "育儿技能",
        domain_legal: "法律",
        domain_mental_health: "心理健康",
        domain_substance_abuse: "物质滥用",
        domain_safety: "安全",
        domain_disabilities: "残疾",
        domain_other_optional: "其他（可选）"
    },
    ar: {
        app_title: "تطبيق SSA",
        dashboard_subtitle: "لوحة معلومات إدارة الحالات",
        new_assessment: "تقييم جديد",
        manage_case_workers: "إدارة الاخصائيين الاجتماعيين",
        analytics: "التحليلات",
        total_case_workers: "إجمالي الاخصائيين الاجتماعيين",
        total_cases: "إجمالي الحالات",
        completed: "مكتمل",
        active_users: "المستخدمون النشطون",
        case_worker_activity: "نشاط الاخصائي الاجتماعي",
        recent_assessments: "التقييمات الأخيرة",
        count_cases: "{count} حالة",
        loading_cases: "جارٍ تحميل الحالات...",
        no_assessments: "لا توجد تقييمات بعد",
        create_first: "أنشئ تقييمك الأول للبدء",
        search_placeholder: "البحث عن طريق اسم العميل أو المعرف...",
        search_button: "بحث",
        delete_assessment_title: "حذف التقييم؟",
        delete_assessment_desc: "لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف التقييم والتسجيلات والنص والدرجات بشكل دائم.",
        cancel: "إلغاء",
        delete: "حذف",
        case_worker: "الاخصائي الاجتماعي",
        role: "الدور",
        cases: "الحالات",
        submitted: "مقدم",
        recordings: "التسجيلات",
        status_created: "أنشئت",
        status_audio_uploaded: "الصوت جاهز",
        status_transcribed: "منسوخ",
        status_analyzed: "تم التحليل",
        report_summary: "ملخص",
        manage_case_worker_menu: "إدارة الاخصائيين الاجتماعيين",
        ai_settings_menu: "إعدادات الذكاء الاصطناعي",
        sign_out: "تسجيل الخروج",
        delete_assessment_tooltip: "حذف التقييم",
        assessment_deleted_toast: "تم حذف التقييم",
        failed_delete_assessment_toast: "فشل حذف التقييم",

        // Case Detail
        dashboard_breadcrumb: "لوحة القيادة",
        case_information: "معلومات الحالة",
        assessment_date: "تاريخ التقييم",
        next_step: "الخطوة التالية",
        view_transcript: "عرض النص",
        view_results: "عرض النتائج",
        view_full_results: "عرض النتائج الكاملة",
        assessment_workflow: "سير عمل التقييم",
        domain_scores_summary: "ملخص درجات المجال",
        assessment_history: "تاريخ التقييم",
        track_progress: "تتبع التقدم عبر تقييمات متعددة",
        current: "الحالي",
        view: "عرض",
        quick_actions: "إجراءات سريعة",
        edit_case_details: "تحرير تفاصيل الحالة",
        save_changes_btn: "حفظ التغييرات",
        saving: "جارٍ الحفظ...",
        export_pdf: "تصدير PDF",
        view_transcript_desc: "مراجعة المحادثة المنسوخة",
        analyze_desc: "تحليل النص مقابل مصفوفة الاكتفاء الذاتي",
        view_results_desc: "مراجعة وتعديل درجات المجال",
        record_desc: "ابدأ تسجيل محادثة التقييم",
        success_case_updated: "تم تحديث تفاصيل الحالة",
        error_update_case: "فشل تحديث تفاصيل الحالة",
        transcript: "النص",
        results: "النتائج",

        // New Case
        new_assessment_title: "تقييم جديد",
        new_assessment_subtitle: "إنشاء حالة جديدة للتقييم",
        back: "عودة",
        client_info_title: "معلومات العميل",
        client_info_desc: "أدخل تفاصيل العميل لبدء التقييم",
        client_name_label: "اسم العميل",
        client_id_label: "معرف العميل",
        postal_code_label: "الرمز البريدي",
        enter_name_placeholder: "أدخل الاسم",
        client_id_placeholder: "مثال: CLT-001",
        postal_code_placeholder: "مثال: 10001",
        client_id_help: "مُعرف فريد لهذا العميل (للخصوصية)",
        create_start_recording: "إنشاء وبدء التسجيل",
        creating: "جارٍ الإنشاء...",
        error_client_name_required: "اسم العميل مطلوب",
        error_client_id_required: "معرف العميل مطلوب",
        error_postal_code_required: "الرمز البريدي مطلوب",
        success_case_created: "تم إنشاء الحالة بنجاح",
        error_create_case: "فشل إنشاء الحالة",

        // Recording
        record_conversation: "تسجيل المحادثة",
        microphone: "ميكروفون",
        select_device: "اختر الجهاز",
        consent: "موافقة",
        consent_confirmation: "أؤكد أنه تم الحصول على الموافقة.",
        recorder: "مسجل",
        status_recording: "جارٍ التسجيل...",
        status_paused: "متوقف مؤقتًا",
        status_saved: "تم الحفظ",
        status_ready: "جاهز",
        click_to_start: "انقر فوق الميكروفون للبدء",
        or: "أو",
        upload_audio: "تحميل ملف صوتي",
        upload_help: "MP3, WAV, M4A (الحد الأقصى 200 ميجابايت)",
        preview: "معاينة",
        discard: "تجاهل",
        process_recording: "معالجة التسجيل",
        status_uploading: "جارٍ تحميل الصوت...",
        status_transcribing: "جارٍ النسخ...",
        uploaded_recordings: "التسجيلات المحملة",
        deselect_all: "إلغاء تحديد الكل",
        select_all: "تحديد الكل",
        transcribe_selected: "نسخ المحدد",
        save_recording_title: "حفظ التسجيل",
        save_recording_desc: "أعط هذا التسجيل اسمًا ذا مغزى لمساعدتك في التعرف عليه لاحقًا.",
        recording_name_label: "اسم التسجيل",
        delete_recording_title: "حذف التسجيل؟",
        delete_recording_desc: "هل أنت متأكد من أنك تريد حذف هذا التسجيل نهائيًا؟ لا يمكن التراجع عن هذا الإجراء.",
        discard_recording_title: "تجاهل التسجيل؟",
        discard_recording_desc: "سيؤدي هذا إلى إزالة التسجيل الحالي غير المحفوظ. لا يمكن التراجع عن هذا الإجراء.",

        // Transcript
        review_edit_transcript: "مراجعة وتحرير النص",
        save_changes: "حفظ التغييرات",
        run_analysis: "تشغيل التحليل",
        run_matrix_analysis: "تشغيل تحليل المصفوفة",
        analyzing_status: "جارٍ التحليل...",
        no_transcript_title: "لا يوجد نص متاح",
        no_transcript_desc: "سجل وانسخ محادثة أولاً",
        go_to_recording: "الانتقال إلى التسجيل",
        edit_transcript_title: "تحرير النص",
        edit_transcript_desc: "راجع وحرر النص أدناه. صحح أي أخطاء قبل تشغيل التحليل.",
        editable_text_label: "نص قابل للتحرير",
        transcript_placeholder: "نص المحادثة...",
        about_matrix_analysis: "حول تحليل المصفوفة",
        matrix_analysis_desc: "سيقوم الذكاء الاصطناعي بتحليل هذا النص مقابل جميع مجالات مصفوفة الاكتفاء الذاتي الـ 19. سيتلقى كل مجال درجة من 1-5 بناءً على الأدلة الموجودة في المحادثة. ستتمكن من مراجعة وتجاوز أي درجات قبل الانتهاء.",
        analyzing_transcript_title: "جارٍ تحليل النص...",
        analyzing_transcript_desc: "يقوم الذكاء الاصطناعي لدينا بمراجعة المحادثة بعناية عبر جميع مجالات مصفوفة الاكتفاء الذاتي الـ 19.",
        estimated_time: "الوقت المقدر",
        time_estimate: "1-2 دقيقة",
        do_not_close: "يرجى عدم إغلاق هذه النافذة أو الانتقال بعيدًا.",
        save_before_analyzing: "حفظ التغييرات قبل التحليل",
        run_analysis_tooltip: "تشغيل التحليل",
        apparent_contradictions_title: "التناقضات المكتشفة",
        apparent_contradictions_desc: "المعلومات المقدمة من العميل والتي تبدو متعارضة مع بيانات أخرى.",
        no_contradictions: "لم يتم الكشف عن أي تناقضات.",
        add_contradiction: "إضافة تناقض",
        analysis_config_title: "إعدادات التحليل",
        analysis_config_desc: "اختر اللغة المستهدفة لتحليل الذكاء الاصطناعي وإنشاء التقارير.",
        target_language_label: "اللغة المستهدفة",
        select_language_placeholder: "اختر اللغة المستهدفة",
        language_analysis_note: "سيقوم الذكاء الاصطناعي بإنشاء مبررات الدرجات وتقرير الحالة الكامل باللغة المختارة.",
        start_analysis_btn: "بدء التحليل",
        error_load_transcript: "فشل تحميل النص",
        success_transcript_updated: "تم تحديث النص",
        error_save_transcript: "فشل حفظ النص",
        success_analysis_complete: "اكتمل التحليل",
        error_analysis_failed: "فشل التحليل",
        needs_review: "يحتاج إلى مراجعة",
        reviewed: "تمت المراجعة",
        goal_label: "هدف",
        ai_score_label: "درجة الذكاء الاصطناعي",
        confidence_label: "الثقة",
        final_score_label: "نهائي",
        ai_justification_title: "مبرر الذكاء الاصطناعي",
        no_justification: "لم يتم تقديم مبرر.",
        evidence_quotes_title: "اقتباسات الأدلة",
        no_evidence: "لم يتم العثور على اقتباسات أدلة.",
        show_score_definitions: "إظهار تعريفات الدرجات",
        review_adjust_title: "المراجعة والتعديل",
        final_score_range_label: "الدرجة النهائية (0-5)",
        select_score_placeholder: "اختر الدرجة",
        score_0_desc: "0 - غير متاح أو معلومات غير كافية",
        score_1_desc: "1 - في أزمة",
        score_2_desc: "2 - معرض للخطر",
        score_3_desc: "3 - آمن",
        score_4_desc: "4 - بناء القدرات",
        score_5_desc: "5 - مزدهر",
        mark_as_goal: "تحديد كهدف للمشارك",
        notes_label: "ملاحظات",
        add_notes_placeholder: "إضافة ملاحظات التقييم...",
        confirm_save: "تأكيد وحفظ",
        assessment_submitted_locked: "تم تقديم التقييم. التعديلات مغلقة.",
        loading_report: "جاري تحميل التقرير...",
        no_report_generated_title: "لم يتم إنشاء تقرير",
        no_report_generated_desc: "قم بإنشاء تقرير حالة شامل يتضمن القسم الذاتي، الموضوعي، التقييم، والخطة (SOAP)، بالإضافة إلى نقاط القوة الرئيسية وخطة العمل.",
        generating_report: "جاري إنشاء تقرير الذكاء الاصطناعي...",
        generate_report_btn: "إنشاء التقرير",
        generated_on: "تم الإنشاء في",
        at_time: "في",
        edit_report_btn: "تعديل التقرير",
        download_pdf_btn: "تحميل PDF",
        revert_to_original: "الرجوع للأصل",
        loading: "جاري التحميل...",
        case_not_found: "الحالة غير موجودة",
        describe_inconsistency: "وصف التناقض...",
        no_summary: "لا يوجد محتوى ملخص.",
        subjective_title: "1. القسم الذاتي",
        subjective_subtitle: "احتياجات العميل ووجهة نظره.",
        subjective_placeholder: "أدخل النتائج الذاتية...",
        no_subjective: "لا يوجد محتوى ذاتي.",
        objective_title: "2. القسم الموضوعي",
        objective_subtitle: "الحقائق الملحوظة ودرجات التقييم.",
        objective_placeholder: "أدخل النتائج الموضوعية...",
        no_objective: "لا يوجد محتوى موضوعي.",
        assessment_title: "3. التقييم",
        assessment_subtitle: "تحليل مهني للوضع.",
        assessment_placeholder: "أدخل تحليل التقييم...",
        no_assessment: "لا يوجد محتوى تقييم.",
        plan_title: "4. الخطة",
        plan_subtitle: "الخطوات التالية والتوصيات.",
        plan_placeholder: "أدخل الخطة...",
        no_plan: "لا يوجد محتوى خطة.",
        key_strengths_title: "نقاط القوة الرئيسية",
        no_strengths: "لم يتم تحديد نقاط قوة رئيسية.",
        add_strength_btn: "إضافة نقطة قوة",
        action_plan_title: "أهداف خطة العمل",
        domain_label: "المجال",
        remove_btn: "إزالة",
        domain_placeholder: "المجال (مثال: السكن)",
        goal_placeholder: "هدف محدد...",
        no_action_plan: "لا توجد عناصر في خطة العمل.",
        add_action_goal_btn: "إضافة هدف عمل",
        assessment_scores_tab: "درجات التقييم",
        case_report_tab: "تقرير الحالة",
        require_review_msg: "مجالات تتطلب المراجعة. يجب تأكيد الدرجة أو تعديلها قبل التقديم.",
        total_score_label: "إجمالي الدرجة",
        pending_review_label: "قيد المراجعة",
        goals_set_label: "الأهداف المحددة",
        domain_scores_title: "درجات المجالات",
        assessment_locked_msg: "التقييم مقفل.",
        review_ai_scores_desc: "راجع الدرجات التي أنشأها الذكاء الاصطناعي وقم بإجراء التعديلات.",
        submit_assessment_title: "تقديم التقييم؟",
        submit_assessment_desc: "بمجرد التقديم، سيتم قفل هذا التقييم ولا يمكن تعديله من قبل المستخدمين العاديين. هل أنت متأكد أنك تريد المتابعة؟",
        submitting: "جاري التقديم...",
        submit_confirm_btn: "نعم، تقديم",
        status_submitted: "تم التقديم",
        domain_housing: "السكن",
        domain_employment: "التوظيف",
        domain_income: "الدخل",
        domain_food: "الغذاء",
        domain_child_care: "رعاية الأطفال",
        domain_childrens_education: "تعليم الأطفال",
        domain_adult_education: "تعليم الكبار",
        domain_health_care_coverage: "تغطية الرعاية الصحية",
        domain_life_skills: "المهارات الحياتية",
        domain_family_social_relations: "العلاقات الأسرية/الاجتماعية",
        domain_mobility: "التنقل",
        domain_community_involvement: "المشاركة المجتمعية",
        domain_parenting_skills: "مهارات التربية",
        domain_legal: "قانوني",
        domain_mental_health: "الصحة العقلية",
        domain_substance_abuse: "تعاطي المخدرات",
        domain_safety: "الأمان",
        domain_disabilities: "الإعاقات",
        domain_other_optional: "أخرى (اختياري)"
    },
    // Adding placeholder/partial translations for requested languages
    // Haitian Creole (ht)
    ht: {
        app_title: "Aplikasyon SSA",
        dashboard_subtitle: "Tablodbò Jesyon Ka",
        new_assessment: "Nouvo Evalyasyon",
        manage_case_workers: "Jere Travayè Ka yo",
        analytics: "Analitik",
        total_case_workers: "Total Travayè Ka yo",
        total_cases: "Total Ka yo",
        completed: "Konplete",
        active_users: "Itilizatè Aktif",
        case_worker_activity: "Aktivite Travayè Ka",
        recent_assessments: "Evalyasyon Dènye",
        count_cases: "{count} ka",
        loading_cases: "Chaje ka yo...",
        no_assessments: "Pa gen evalyasyon ankò",
        create_first: "Kreye premye evalyasyon ou pou kòmanse",
        search_placeholder: "Chèche pa non kliyan oswa ID...",
        search_button: "Chèche",
        delete_assessment_title: "Efase Evalyasyon?",
        delete_assessment_desc: "Aksyon sa a pa ka defèt. Sa a pral efase evalyasyon an, anrejistreman, transkripsyon, ak nòt nèt.",
        cancel: "Anile",
        delete: "Efase",
        case_worker: "Travayè Ka",
        role: "Wòl",
        cases: "Ka yo",
        submitted: "Soumèt",
        recordings: "Anrejistreman",
        status_created: "Kreye",
        status_audio_uploaded: "Odyo Pare",
        status_transcribed: "Transkri",
        status_analyzed: "Analize",
        report_summary: "Rezime",
        manage_case_worker_menu: "Jesyon Travayè Ka",
        ai_settings_menu: "Anviwònman AI",
        sign_out: "Dekonekte",
        delete_assessment_tooltip: "Efase Evalyasyon",
        assessment_deleted_toast: "Evalyasyon efase",
        failed_delete_assessment_toast: "Echèk pou efase evalyasyon",

        // Login
        login_subtitle: "Konekte pou jwenn aksè nan sistèm evalyasyon an",
        email_label: "Imèl",
        email_placeholder: "Antre imèl ou",
        password_label: "Modpas",
        password_placeholder: "Antre modpas ou",
        sign_in: "Konekte",
        signing_in: "Ap konekte...",
        enter_email_password: "Tanpri antre imèl ak modpas",
        welcome: "Byenveni",
        invalid_credentials: "Kalifikasyon inyore",

        // Case Detail
        dashboard_breadcrumb: "Tablodbò",
        case_information: "Enfòmasyon sou Ka",
        assessment_date: "Dat Evalyasyon",
        next_step: "Pwochen Etap",
        view_transcript: "Wè Transkripsyon",
        view_results: "Wè Rezilta",
        view_full_results: "Wè Rezilta Konplè",
        assessment_workflow: "Workflow Evalyasyon",
        domain_scores_summary: "Rezime Nòt Domèn",
        assessment_history: "Istwa Evalyasyon",
        track_progress: "Swiv pwogrè atravè plizyè evalyasyon",
        current: "Kounye a",
        view: "Wè",
        quick_actions: "Aksyon Rapid",
        edit_case_details: "Modifye Detay Ka",
        save_changes_btn: "Sove Chanjman",
        saving: "Anrejistreman...",
        export_pdf: "Ekspòte PDF",
        view_transcript_desc: "Revize konvèsasyon transkri",
        analyze_desc: "Analize transkripsyon an kont Matris Oto-Sifizans lan",
        view_results_desc: "Revize ak ajiste nòt domèn",
        record_desc: "Kòmanse anrejistre konvèsasyon evalyasyon an",
        success_case_updated: "Detay ka mete ajou",
        error_update_case: "Echèk pou mete ajou detay ka",
        transcript: "Transkripsyon",
        results: "Rezilta",

        // New Case
        new_assessment_title: "Nouvo Evalyasyon",
        new_assessment_subtitle: "Kreye yon nouvo ka pou evalyasyon",
        back: "Retounen",
        client_info_title: "Enfòmasyon Kliyan",
        client_info_desc: "Antre detay kliyan pou kòmanse evalyasyon an",
        client_name_label: "Non Kliyan",
        client_id_label: "ID Kliyan",
        postal_code_label: "Kòd Postal",
        enter_name_placeholder: "Antre non",
        client_id_placeholder: "eg. CLT-001",
        postal_code_placeholder: "eg. 10001",
        client_id_help: "Idantifyan inik pou kliyan sa a (pou konfidansyalite)",
        create_start_recording: "Kreye & Kòmanse Anrejistre",
        creating: "Kreye...",
        error_client_name_required: "Non kliyan obligatwa",
        error_client_id_required: "ID kliyan obligatwa",
        error_postal_code_required: "Kòd Postal obligatwa",
        success_case_created: "Ka kreye avèk siksè",
        error_create_case: "Echèk pou kreye ka",

        // Recording
        record_conversation: "Anrejistre Konvèsasyon",
        microphone: "Mikwofòn",
        select_device: "Chwazi aparèy",
        consent: "Konsantman",
        consent_confirmation: "Mwen konfime ke konsantman te jwenn.",
        recorder: "Anrejistrè",
        status_recording: "Ap anrejistre...",
        status_paused: "Poz",
        status_saved: "Sove",
        status_ready: "Pare",
        click_to_start: "Klike sou mikwofòn pou kòmanse",
        or: "OSWA",
        upload_audio: "Telechaje Fichye Odyo",
        upload_help: "MP3, WAV, M4A (Max 200MB)",
        preview: "Apèsi",
        discard: "Jete",
        process_recording: "Trete Anrejistreman",
        status_uploading: "Ap telechaje odyo...",
        status_transcribing: "Ap transkri...",
        uploaded_recordings: "Anrejistreman Telechaje",
        deselect_all: "Deseleksyone Tout",
        select_all: "Chwazi Tout",
        transcribe_selected: "Transkri Seleksyone",
        save_recording_title: "Sove Anrejistreman",
        save_recording_desc: "Bay anrejistreman sa a yon non sansib pou ede ou idantifye li pita.",
        recording_name_label: "Non Anrejistreman",
        delete_recording_title: "Efase Anrejistreman?",
        delete_recording_desc: "Èske ou sèten ou vle efase anrejistreman sa a nèt? Aksyon sa a pa ka defèt.",
        discard_recording_title: "Jete Anrejistreman?",
        discard_recording_desc: "Sa a pral retire anrejistreman aktyèl la ki pa sove. Aksyon sa a pa ka defèt.",

        // Transcript
        review_edit_transcript: "Revize & Modifye Transkripsyon",
        save_changes: "Sove Chanjman",
        run_analysis: "Kouri Analiz",
        run_matrix_analysis: "Kouri Analiz Matris",
        analyzing_status: "Analize...",
        no_transcript_title: "Pa gen transkripsyon disponib",
        no_transcript_desc: "Anrejistre epi transkri yon konvèsasyon an premye",
        go_to_recording: "Ale nan Anrejistreman",
        edit_transcript_title: "Modifye Transkripsyon",
        edit_transcript_desc: "Revize epi modifye transkripsyon anba a. Korije nenpòt erè anvan ou kouri analiz la.",
        editable_text_label: "Tèks Editab",
        transcript_placeholder: "Tèks transkripsyon...",
        about_matrix_analysis: "Konsènan Analiz Matris",
        matrix_analysis_desc: "AI pral analize transkripsyon sa a kont tout 19 domèn Matris Oto-Sifizans lan. Chak domèn pral resevwa yon nòt de 1-5 ki baze sou prèv yo jwenn nan konvèsasyon an. Ou pral kapab revize epi pase sou nenpòt nòt anvan ou fini.",
        analyzing_transcript_title: "Analize Transkripsyon...",
        analyzing_transcript_desc: "AI nou an ap revize konvèsasyon an ak anpil atansyon atravè tout 19 domèn Matris Oto-Sifizans lan.",
        estimated_time: "Tan Estimasyon",
        time_estimate: "1-2 minit",
        do_not_close: "Tanpri pa fèmen fenèt sa a oswa navige ale.",
        save_before_analyzing: "Sove chanjman anvan analiz",
        run_analysis_tooltip: "Kouri Analiz",
        analysis_config_title: "Konfigirasyon Analiz",
        analysis_config_desc: "Chwazi lang sib pou analiz AI ak jenerasyon rapò.",
        target_language_label: "Lang Sib",
        select_language_placeholder: "Chwazi lang sib",
        language_analysis_note: "AI pral jenere jistifikasyon nòt ak rapò ka konplè nan lang ou chwazi a.",
        start_analysis_btn: "Kòmanse Analiz",
        error_load_transcript: "Echèk nan chaje transkripsyon an",
        success_transcript_updated: "Transkripsyon mete ajou",
        error_save_transcript: "Echèk nan sove transkripsyon an",
        success_analysis_complete: "Analiz konplè",
        error_analysis_failed: "Analiz echwe",
        needs_review: "Bezwen Revizyon",
        reviewed: "Revize",
        goal_label: "Objektif",
        ai_score_label: "Nòt AI",
        confidence_label: "Konfyans",
        final_score_label: "Final",
        ai_justification_title: "Jistifikasyon AI",
        no_justification: "Pa gen jistifikasyon yo bay.",
        evidence_quotes_title: "Sityasyon Prèv",
        no_evidence: "Pa gen sityasyon prèv yo jwenn.",
        show_score_definitions: "Montre Definisyon yo",
        review_adjust_title: "Revize & Ajiste",
        final_score_range_label: "Nòt Final (0-5)",
        select_score_placeholder: "Chwazi nòt",
        score_0_desc: "0 - N/A oswa Enfòmasyon ensifizan",
        score_1_desc: "1 - Nan Kriz",
        score_2_desc: "2 - Vilnerab",
        score_3_desc: "3 - An sekirite",
        score_4_desc: "4 - Ap bati kapasite",
        score_5_desc: "5 - Ap Briye",
        mark_as_goal: "Make kòm objektif patisipan an",
        notes_label: "Nòt",
        add_notes_placeholder: "Ajoute nòt evalyasyon...",
        confirm_save: "Konfime & Sove",
        assessment_submitted_locked: "Evalyasyon soumèt. Edisyon fèmen.",
        loading_report: "Ap chaje rapò...",
        no_report_generated_title: "Pa gen rapò ki pwodui",
        no_report_generated_desc: "Pwodui yon rapò ka konplè ki gen ladan Subjectif, Objektif, Evalyasyon, Plan (SOAP), Fòs Kle, ak Plan Aksyon.",
        generating_report: "Ap pwodui rapò AI...",
        generate_report_btn: "Pwodui Rapò",
        generated_on: "Pwodui nan dat",
        at_time: "nan",
        edit_report_btn: "Modifye Rapò",
        download_pdf_btn: "Telechaje PDF",
        revert_to_original: "Retounen nan orijinal la",
        loading: "Ap chaje...",
        case_not_found: "Ka pa jwenn",
        describe_inconsistency: "Dekri enkonsistans...",
        no_summary: "Pa gen kontni rezime.",
        subjective_title: "1. Subjectif",
        subjective_subtitle: "Besoins ak pèspektiv kliyan an deklare.",
        subjective_placeholder: "Antre konklizyon subjectif...",
        no_subjective: "Pa gen kontni subjectif.",
        objective_title: "2. Objektif",
        objective_subtitle: "Reyalite obsèvab ak nòt evalyasyon.",
        objective_placeholder: "Antre konklizyon objektif...",
        no_objective: "Pa gen kontni objektif.",
        assessment_title: "3. Evalyasyon",
        assessment_subtitle: "Analiz pwofesyonèl sitiyasyon an.",
        assessment_placeholder: "Antre analiz evalyasyon...",
        no_assessment: "Pa gen kontni evalyasyon.",
        plan_title: "4. Plan",
        plan_subtitle: "Pwochen etap ak rekòmandasyon.",
        plan_placeholder: "Antre plan...",
        no_plan: "Pa gen kontni plan.",
        key_strengths_title: "Fòs Kle",
        no_strengths: "Pa gen fòs kle yo idantifye.",
        add_strength_btn: "Ajoute Fòs",
        action_plan_title: "Objektif Plan Aksyon",
        domain_label: "Domèn",
        remove_btn: "Retire",
        domain_placeholder: "Domèn (ex. Lojman)",
        goal_placeholder: "Objektif espesifik...",
        no_action_plan: "Pa gen eleman nan plan aksyon.",
        add_action_goal_btn: "Ajoute Objektif Aksyon",
        assessment_scores_tab: "Nòt Evalyasyon",
        case_report_tab: "Rapò Ka",
        require_review_msg: "domèn bezwen revizyon. Ou dwe konfime nòt la oswa ajiste yo anvan ou soumèt.",
        total_score_label: "Nòt Total",
        pending_review_label: "An atant de revizyon",
        goals_set_label: "Objektif fikse",
        domain_scores_title: "Nòt Domèn",
        assessment_locked_msg: "Evalyasyon an fèmen.",
        review_ai_scores_desc: "Revize nòt AI pwodui yo epi fè ajisteman.",
        submit_assessment_title: "Soumèt Evalyasyon?",
        submit_assessment_desc: "Yon fwa soumèt, evalyasyon sa a ap fèmen epi itilizatè regilye pa kapab modifye li. Èske ou sèten ou vle kontinye?",
        submitting: "Ap soumèt...",
        submit_confirm_btn: "Wi, Soumèt",
        status_submitted: "Soumèt",
        domain_housing: "Lojman",
        domain_employment: "Travay",
        domain_income: "Revni",
        domain_food: "Manje",
        domain_child_care: "Swen Timoun",
        domain_childrens_education: "Edikasyon Timoun",
        domain_adult_education: "Edikasyon Granmoun",
        domain_health_care_coverage: "Kouvèti Sante",
        domain_life_skills: "Ladrès lavi",
        domain_family_social_relations: "Relasyon Fanmi/Sosyal",
        domain_mobility: "Mobilite",
        domain_community_involvement: "Patisipasyon Kominotè",
        domain_parenting_skills: "Ladrès Paran",
        domain_legal: "Legal",
        domain_mental_health: "Sante Mantal",
        domain_substance_abuse: "Abiz Sibtans",
        domain_safety: "Sekirite",
        domain_disabilities: "Andikap",
        domain_other_optional: "Lòt (Si ou vle)"
    },
    // Somali (so)
    so: {
        app_title: "Codsiga SSA",
        dashboard_subtitle: "Dashboorka Maamulka Kiiska",
        new_assessment: "Qiimayn Cusub",
        manage_case_workers: "Maamul Shaqaalaha Kiiska",
        analytics: "Falanqaynta",
        total_case_workers: "Wadarta Shaqaalaha Kiiska",
        total_cases: "Wadarta Kiisaska",
        completed: "Dhameystiray",
        active_users: "Isticmaalayaasha Firfircoon",
        case_worker_activity: "Dhaqdhaqaaqa Shaqaalaha Kiiska",
        recent_assessments: "Qiimayntii Dhawaan",
        count_cases: "{count} kiis",
        loading_cases: "Soo dejinta kiisaska...",
        no_assessments: "Wali ma jiraan qiimayn",
        create_first: "Samee qiimayntaada ugu horeysa si aad u bilowdo",
        search_placeholder: "Ku raadi magaca macmiilka ama ID...",
        search_button: "Raadi",
        delete_assessment_title: "Tirtir Qiimaynta?",
        delete_assessment_desc: "Ficilkan lama noqon karo. Tani waxay si jooto ah u tirtiri doontaa qiimaynta, duubabka, qoraalka, iyo dhibcaha.",
        cancel: "Jooji",
        delete: "Tirtir",
        case_worker: "Shaqaalaha Kiiska",
        role: "Doorka",
        cases: "Kiisaska",
        submitted: "La gudbiyay",
        recordings: "Duubabka",
        status_created: "La abuuray",
        status_audio_uploaded: "Codka Diyaarka ah",
        status_transcribed: "Qoraal",
        status_analyzed: "La falanqeeyay",
        status_submitted: "La gudbiyay",
        manage_case_worker_menu: "Maamulka Shaqaalaha Kiiska",
        ai_settings_menu: "Dejinta AI",
        sign_out: "Ka bax",
        delete_assessment_tooltip: "Tirtir Qiimaynta",
        assessment_deleted_toast: "Qiimaynta waa la tirtiray",
        failed_delete_assessment_toast: "Waa lagu guuldareystay in la tirtiro qiimaynta",

        // Login
        login_subtitle: "Soo gal si aad u gasho nidaamka qiimaynta",
        email_label: "Iimayl",
        email_placeholder: "Geli iimaylkaaga",
        password_label: "Furaha",
        password_placeholder: "Geli furahaaga",
        sign_in: "Soo gal",
        signing_in: "Soo galaya...",
        enter_email_password: "Fadlan geli iimaylka iyo furaha",
        welcome: "Soo dhawoow",
        invalid_credentials: "Aqoonsi khaldan",

        // Case Detail
        dashboard_breadcrumb: "Dashboorka",
        case_information: "Macluumaadka Kiiska",
        assessment_date: "Taariikhda Qiimaynta",
        next_step: "Tallaabada Xigta",
        view_transcript: "Eeg Qoraalka",
        view_results: "Eeg Natiijooyinka",
        view_full_results: "Eeg Natiijooyinka Buuxa",
        assessment_workflow: "Habka Shaqada Qiimaynta",
        domain_scores_summary: "Soo koobida Dhibcaha Domainka",
        assessment_history: "Taariikhda Qiimaynta",
        track_progress: "La soco horumarka dhowr qiimeyn",
        current: "Hadda",
        view: "Eeg",
        quick_actions: "Ficilada Degdega ah",
        edit_case_details: "Wax ka beddel Faahfaahinta Kiiska",
        save_changes_btn: "Badbaadi Isbedelada",
        saving: "Badbaadinaya...",
        export_pdf: "Dhoofinta PDF",
        view_transcript_desc: "Dib u eeg wada hadalka qoran",
        analyze_desc: "Falanqee qoraalka marka loo eego Matrix-ka Isku-filnaanshaha",
        view_results_desc: "Dib u eeg oo hagaaji dhibcaha domainka",
        record_desc: "Bilow duubista wada hadalka qiimaynta",
        success_case_updated: "Faahfaahinta kiiska waa la cusbooneysiiyay",
        error_update_case: "Waa lagu guuldareystay in la cusbooneysiiyo faahfaahinta kiiska",
        transcript: "Qoraal",
        results: "Natiijooyinka",

        // New Case
        new_assessment_title: "Qiimayn Cusub",
        new_assessment_subtitle: "Samee kiis cusub oo qiimayn ah",
        back: "Dib",
        client_info_title: "Macluumaadka Macmiilka",
        client_info_desc: "Geli faahfaahinta macmiilka si aad u bilowdo qiimaynta",
        client_name_label: "Magaca Macmiilka",
        client_id_label: "Aqoonsiga Macmiilka",
        postal_code_label: "Koodhka Boostada",
        enter_name_placeholder: "Geli magaca",
        client_id_placeholder: "tusaale CLT-001",
        postal_code_placeholder: "tusaale 10001",
        client_id_help: "Aqoonsi gaar ah macmiilkan (loogu talagalay sirta)",
        create_start_recording: "Abuur & Bilow Duubista",
        creating: "Samaynaya...",
        error_client_name_required: "Magaca macmiilka waa loo baahan yahay",
        error_client_id_required: "Aqoonsiga macmiilka waa loo baahan yahay",
        error_postal_code_required: "Koodhka Boostada waa loo baahan yahay",
        success_case_created: "Kiiska si guul leh ayaa loo abuuray",
        error_create_case: "Waa lagu guuldareystay in la sameeyo kiis",

        // Recording
        record_conversation: "Duub Wada hadalka",
        microphone: "Makarafoonka",
        select_device: "Dooro aalad",
        consent: "Oggolaansho",
        consent_confirmation: "Waxaan xaqiijinayaa in oggolaansho la helay.",
        recorder: "Duube",
        status_recording: "Duubaya...",
        status_paused: "Hakaday",
        status_saved: "Badbaadiyay",
        status_ready: "Diyaar",
        click_to_start: "Guji makarafoonka si aad u bilowdo",
        or: "AMA",
        upload_audio: "Soo rar Faylka Codka",
        upload_help: "MP3, WAV, M4A (Ugu badnaan 200MB)",
        preview: "Horu-u-eegis",
        discard: "Tuur",
        process_recording: "Habraaca Duubista",
        status_uploading: "Soo raraya codka...",
        status_transcribing: "Qoraya...",
        uploaded_recordings: "Duubabka la soo raray",
        deselect_all: "Ka saar dhammaan",
        select_all: "Dooro dhammaan",
        transcribe_selected: "Qor xulashada",
        save_recording_title: "Badbaadi Duubista",
        save_recording_desc: "Sii duubistan magac macno leh si ay kaaga caawiso inaad hadhow aqoonsato.",
        recording_name_label: "Magaca Duubista",
        delete_recording_title: "Tirtir Duubista?",
        delete_recording_desc: "Ma hubtaa inaad rabto inaad si jooto ah u tirtirto duubistan? Ficilkan lama noqon karo.",
        discard_recording_title: "Tuur Duubista?",
        discard_recording_desc: "Tani waxay ka saari doontaa duubista hadda aan la keydin. Ficilkan lama noqon karo.",

        // Transcript
        review_edit_transcript: "Dib u eeg & Wax ka beddel Qoraalka",
        save_changes: "Badbaadi Isbedelada",
        run_analysis: "Wado Falanqaynta",
        run_matrix_analysis: "Wado Falanqaynta Matrix",
        analyzing_status: "Falanqeynaya...",
        no_transcript_title: "Ma jiro qoraal la heli karo",
        no_transcript_desc: "Duub oo qor wada hadal marka hore",
        go_to_recording: "Aad Duubista",
        edit_transcript_title: "Wax ka beddel Qoraalka",
        edit_transcript_desc: "Dib u eeg oo wax ka beddel qoraalka hoose. Sax wixii khaladaad ah ka hor inta aanad wadin falanqaynta.",
        editable_text_label: "Qoraal la beddeli karo",
        transcript_placeholder: "Qoraalka wada hadalka...",
        about_matrix_analysis: "Ku saabsan Falanqaynta Matrix",
        matrix_analysis_desc: "AI waxay falanqeyn doontaa qoraalkan marka loo eego dhammaan 19-ka domain ee Matrix-ka Isku-filnaanshaha. Domain kasta wuxuu heli doonaa dhibco 1-5 ah oo ku saleysan caddeynta laga helay wada hadalka. Waxaad awoodi doontaa inaad dib u eegto oo aad ka gudubto dhibco kasta ka hor inta aanad dhammaystirin.",
        analyzing_transcript_title: "Falanqeynaya Qoraalka...",
        analyzing_transcript_desc: "AI-yada ayaa si taxadar leh u eegaya wada hadalka dhammaan 19-ka domain ee Matrix-ka Isku-filnaanshaha.",
        estimated_time: "Waqtiga La Qiyaasay",
        time_estimate: "1-2 daqiiqo",
        do_not_close: "Fadlan ha xirin daaqadan ama ha ka bixin.",
        save_before_analyzing: "Badbaadi isbedelada ka hor falanqaynta",
        run_analysis_tooltip: "Wado Falanqaynta"
    },
    // Russian (ru)
    ru: {
        app_title: "Приложение SSA",
        dashboard_subtitle: "Панель управления делами",
        new_assessment: "Новая оценка",
        manage_case_workers: "Управление кураторами",
        analytics: "Аналитика",
        total_case_workers: "Всего кураторов",
        total_cases: "Всего дел",
        completed: "Завершено",
        active_users: "Активные пользователи",
        case_worker_activity: "Активность кураторов",
        recent_assessments: "Недавние оценки",
        count_cases: "{count} дел",
        loading_cases: "Загрузка дел...",
        no_assessments: "Оценок пока нет",
        create_first: "Создайте свою первую оценку, чтобы начать",
        search_placeholder: "Поиск по имени клиента или ID...",
        search_button: "Поиск",
        delete_assessment_title: "Удалить оценку?",
        delete_assessment_desc: "Это действие нельзя отменить. Это навсегда удалит оценку, записи, расшифровку и баллы.",
        cancel: "Отмена",
        delete: "Удалить",
        case_worker: "Куратор",
        role: "Роль",
        cases: "Дела",
        submitted: "Отправлено",
        recordings: "Записи",
        status_created: "Создано",
        status_audio_uploaded: "Аудио готово",
        status_transcribed: "Расшифровано",
        status_analyzed: "Проанализировано",
        status_submitted: "Отправлено",
        manage_case_worker_menu: "Управление кураторами",
        ai_settings_menu: "Настройки ИИ",
        sign_out: "Выйти",
        delete_assessment_tooltip: "Удалить оценку",
        assessment_deleted_toast: "Оценка удалена",
        failed_delete_assessment_toast: "Не удалось удалить оценку",

        // Login
        login_subtitle: "Войдите, чтобы получить доступ к системе оценки",
        email_label: "Эл. почта",
        email_placeholder: "Введите вашу эл. почту",
        password_label: "Пароль",
        password_placeholder: "Введите ваш пароль",
        sign_in: "Войти",
        signing_in: "Вход...",
        enter_email_password: "Пожалуйста, введите эл. почту и пароль",
        welcome: "Добро пожаловать",
        invalid_credentials: "Неверные учетные данные",

        // Case Detail
        dashboard_breadcrumb: "Панель",
        case_information: "Информация о деле",
        assessment_date: "Дата оценки",
        next_step: "Следующий шаг",
        view_transcript: "Посмотреть расшифровку",
        view_results: "Посмотреть результаты",
        view_full_results: "Посмотреть полные результаты",
        assessment_workflow: "Рабочий процесс оценки",
        domain_scores_summary: "Сводка баллов по доменам",
        assessment_history: "История оценок",
        track_progress: "Отслеживание прогресса по нескольким оценкам",
        current: "Текущие",
        view: "Просмотр",
        quick_actions: "Быстрые действия",
        edit_case_details: "Редактировать детали дела",
        save_changes_btn: "Сохранить изменения",
        saving: "Сохранение...",
        export_pdf: "Экспорт в PDF",
        view_transcript_desc: "Просмотреть расшифрованную беседу",
        analyze_desc: "Анализировать расшифровку по Матрице самообеспеченности",
        view_results_desc: "Просмотреть и скорректировать баллы области",
        record_desc: "Начать запись беседы оценки",
        success_case_updated: "Детали дела обновлены",
        error_update_case: "Не удалось обновить детали дела",
        transcript: "Расшифровка",
        results: "Результаты",

        // New Case
        new_assessment_title: "Новая оценка",
        new_assessment_subtitle: "Создать новое дело для оценки",
        back: "Назад",
        client_info_title: "Информация о клиенте",
        client_info_desc: "Введите данные клиента, чтобы начать оценку",
        client_name_label: "Имя клиента",
        client_id_label: "ID клиента",
        postal_code_label: "Почтовый индекс",
        enter_name_placeholder: "Введите имя",
        client_id_placeholder: "напр. CLT-001",
        postal_code_placeholder: "напр. 10001",
        client_id_help: "Уникальный идентификатор для этого клиента (для конфиденциальности)",
        create_start_recording: "Создать и начать запись",
        creating: "Создание...",
        error_client_name_required: "Имя клиента обязательно",
        error_client_id_required: "ID клиента обязательно",
        error_postal_code_required: "Почтовый индекс обязателен",
        success_case_created: "Дело успешно создано",
        error_create_case: "Не удалось создать дело",

        // Recording
        record_conversation: "Запись беседы",
        microphone: "Микрофон",
        select_device: "Выбрать устройство",
        consent: "Согласие",
        consent_confirmation: "Я подтверждаю, что согласие получено.",
        recorder: "Диктофон",
        status_recording: "Запись...",
        status_paused: "Пауза",
        status_saved: "Сохранено",
        status_ready: "Готово",
        click_to_start: "Нажмите на микрофон, чтобы начать",
        or: "ИЛИ",
        upload_audio: "Загрузить аудиофайл",
        upload_help: "MP3, WAV, M4A (Макс. 200 МБ)",
        preview: "Предпросмотр",
        discard: "Отменить",
        process_recording: "Обработать запись",
        status_uploading: "Загрузка аудио...",
        status_transcribing: "Расшифровка...",
        uploaded_recordings: "Загруженные записи",
        deselect_all: "Снять все",
        select_all: "Выбрать все",
        transcribe_selected: "Расшифровать выбранное",
        save_recording_title: "Сохранить запись",
        save_recording_desc: "Дайте этой записи понятное имя, чтобы помочь вам идентифицировать ее позже.",
        recording_name_label: "Имя записи",
        delete_recording_title: "Удалить запись?",
        delete_recording_desc: "Вы уверены, что хотите навсегда удалить эту запись? Это действие нельзя отменить.",
        discard_recording_title: "Отменить запись?",
        discard_recording_desc: "Это удалит текущую несохраненную запись. Это действие нельзя отменить.",

        // Transcript
        review_edit_transcript: "Просмотр и редактирование расшифровки",
        save_changes: "Сохранить изменения",
        run_analysis: "Запустить анализ",
        run_matrix_analysis: "Запустить матричный анализ",
        analyzing_status: "Анализ...",
        no_transcript_title: "Нет доступной расшифровки",
        no_transcript_desc: "Сначала запишите и расшифруйте беседу",
        go_to_recording: "Перейти к записи",
        edit_transcript_title: "Редактировать расшифровку",
        edit_transcript_desc: "Просмотрите и отредактируйте расшифровку ниже. Исправьте ошибки перед запуском анализа.",
        editable_text_label: "Редактируемый текст",
        transcript_placeholder: "Текст расшифровки...",
        about_matrix_analysis: "О матричном анализе",
        matrix_analysis_desc: "ИИ проанализирует эту расшифровку по всем 19 областям Матрицы самообеспеченности. Каждая область получит оценку от 1 до 5 на основе доказательств, найденных в беседе. Вы сможете просмотреть и переопределить любые оценки перед завершением.",
        analyzing_transcript_title: "Анализ расшифровки...",
        analyzing_transcript_desc: "Наш ИИ внимательно просматривает беседу по всем 19 областям Матрицы самообеспеченности.",
        estimated_time: "Расчетное время",
        time_estimate: "1-2 минуты",
        do_not_close: "Пожалуйста, не закрывайте это окно и не переходите на другую страницу.",
        save_before_analyzing: "Сохраните изменения перед анализом",
        run_analysis_tooltip: "Запустить анализ"
    },
    // Swahili (sw)
    sw: {
        app_title: "Programu ya SSA",
        dashboard_subtitle: "Dashibodi ya Usimamizi wa Kesi",
        new_assessment: "Tathmini Mpya",
        manage_case_workers: "Dhibiti Wafanyakazi wa Kesi",
        analytics: "Uchambuzi",
        total_case_workers: "Jumla ya Wafanyakazi wa Kesi",
        total_cases: "Jumla ya Kesi",
        completed: "Imekamilika",
        active_users: "Watumiaji Wanaofanya Kazi",
        case_worker_activity: "Shughuli ya Mfanyakazi wa Kesi",
        recent_assessments: "Tathmini za Hivi Karibuni",
        count_cases: "Kesi {count}",
        loading_cases: "Inapakia kesi...",
        no_assessments: "Hakuna tathmini bado",
        create_first: "Unda tathmini yako ya kwanza ili kuanza",
        search_placeholder: "Tafuta kwa jina la mteja au kitambulisho...",
        search_button: "Tafuta",
        delete_assessment_title: "Futa Tathmini?",
        delete_assessment_desc: "Hatua hii haiwezi kubatilishwa. Hii itafuta kabisa tathmini, rekodi, manukuu, na alama.",
        cancel: "Ghairi",
        delete: "Futa",
        case_worker: "Mfanyakazi wa Kesi",
        role: "Jukumu",
        cases: "Kesi",
        submitted: "Imewasilishwa",
        recordings: "Rekodi",
        status_created: "Imeundwa",
        status_audio_uploaded: "Sauti Tayari",
        status_transcribed: "Imenakiliwa",
        status_analyzed: "Imechambuliwa",
        status_submitted: "Imewasilishwa",
        manage_case_worker_menu: "Usimamizi wa Wafanyakazi wa Kesi",
        ai_settings_menu: "Mipangilio ya AI",
        sign_out: "Ondoka",
        delete_assessment_tooltip: "Futa Tathmini",
        assessment_deleted_toast: "Tathmini imefutwa",
        failed_delete_assessment_toast: "Imeshindwa kufuta tathmini",

        // Login
        login_subtitle: "Ingia ili kupata mfumo wa tathmini",
        email_label: "Barua pepe",
        email_placeholder: "Ingiza barua pepe yako",
        password_label: "Nenosiri",
        password_placeholder: "Ingiza nenosiri lako",
        sign_in: "Ingia",
        signing_in: "Inaingia...",
        enter_email_password: "Tafadhali ingiza barua pepe na nenosiri",
        welcome: "Karibu",
        invalid_credentials: "Vitambulisho visivyo sahihi",

        // Case Detail
        dashboard_breadcrumb: "Dashibodi",
        case_information: "Taarifa za Kesi",
        assessment_date: "Tarehe ya Tathmini",
        next_step: "Hatua Inayofuata",
        view_transcript: "Angalia Manukuu",
        view_results: "Angalia Matokeo",
        view_full_results: "Angalia Matokeo Kamili",
        assessment_workflow: "Mchakato wa Tathmini",
        domain_scores_summary: "Muhtasari wa Alama za Kikoa",
        assessment_history: "Historia ya Tathmini",
        track_progress: "Fuatilia maendeleo katika tathmini nyingi",
        current: "Sasa",
        view: "Angalia",
        quick_actions: "Hatua za Haraka",
        edit_case_details: "Hariri Maelezo ya Kesi",
        save_changes_btn: "Hifadhi Mabadiliko",
        saving: "Inahifadhi...",
        export_pdf: "Hamisha PDF",
        view_transcript_desc: "Pitia mazungumzo yaliyonakiliwa",
        analyze_desc: "Chambua manukuu dhidi ya Matrix ya Kujitosheleza",
        view_results_desc: "Pitia na urekebishe alama za kikoa",
        record_desc: "Anza kurekodi mazungumzo ya tathmini",
        success_case_updated: "Maelezo ya kesi yalisasishwa",
        error_update_case: "Imeshindwa kusasisha maelezo ya kesi",
        transcript: "Manukuu",
        results: "Matokeo",

        // New Case
        new_assessment_title: "Tathmini Mpya",
        new_assessment_subtitle: "Unda kesi mpya kwa ajili ya tathmini",
        back: "Nyuma",
        client_info_title: "Taarifa za Mteja",
        client_info_desc: "Ingiza maelezo ya mteja ili kuanza tathmini",
        client_name_label: "Jina la Mteja",
        client_id_label: "Kitambulisho cha Mteja",
        postal_code_label: "Msimbo wa Posta",
        enter_name_placeholder: "Ingiza jina",
        client_id_placeholder: "mfano CLT-001",
        postal_code_placeholder: "mfano 10001",
        client_id_help: "Kitambulisho cha kipekee kwa mteja huyu (kwa faragha)",
        create_start_recording: "Unda & Anza Kurekodi",
        creating: "Inaunda...",
        error_client_name_required: "Jina la mteja linahitajika",
        error_client_id_required: "Kitambulisho cha mteja kinahitajika",
        error_postal_code_required: "Msimbo wa Posta unahitajika",
        success_case_created: "Kesi imeundwa kwa mafanikio",
        error_create_case: "Imeshindwa kuunda kesi",

        // Recording
        record_conversation: "Rekodi Mazungumzo",
        microphone: "Maikrofoni",
        select_device: "Chagua kifaa",
        consent: "Idhini",
        consent_confirmation: "Ninathibitisha kuwa idhini imepatikana.",
        recorder: "Kinasa sauti",
        status_recording: "Inarekodi...",
        status_paused: "Imesitishwa",
        status_saved: "Imehifadhiwa",
        status_ready: "Tayari",
        click_to_start: "Bofya maikrofoni ili kuanza",
        or: "AU",
        upload_audio: "Pakia Faili ya Sauti",
        upload_help: "MP3, WAV, M4A (Upeo 200MB)",
        preview: "Onyesho la kukagua",
        discard: "Tupa",
        process_recording: "Chakata Rekodi",
        status_uploading: "Inapakia sauti...",
        status_transcribing: "Inanakili...",
        uploaded_recordings: "Rekodi Zilizopakiwa",
        deselect_all: "Ondoa Sehemu Zote",
        select_all: "Chagua Yote",
        transcribe_selected: "Nakili Zilizochaguliwa",
        save_recording_title: "Hifadhi Rekodi",
        save_recording_desc: "Ipe rekodi hii jina la maana kukusaidia kuitambua baadaye.",
        recording_name_label: "Jina la Rekodi",
        delete_recording_title: "Futa Rekodi?",
        delete_recording_desc: "Je, una uhakika unataka kufuta rekodi hii kabisa? Hatua hii haiwezi kubatilishwa.",
        discard_recording_title: "Tupa Rekodi?",
        discard_recording_desc: "Hii itaondoa rekodi ya sasa ambayo haijahifadhiwa. Hatua hii haiwezi kubatilishwa.",

        // Transcript
        review_edit_transcript: "Pitia & Hariri Manukuu",
        save_changes: "Hifadhi Mabadiliko",
        run_analysis: "Endesha Uchambuzi",
        run_matrix_analysis: "Endesha Uchambuzi wa Matrix",
        analyzing_status: "Inachambua...",
        no_transcript_title: "Hakuna manukuu yanayopatikana",
        no_transcript_desc: "Rekodi na unakili mazungumzo kwanza",
        go_to_recording: "Nenda kwenye Rekodi",
        edit_transcript_title: "Hariri Manukuu",
        edit_transcript_desc: "Pitia na uhariri manukuu hapa chini. Sahihisha makosa yoyote kabla ya kuendesha uchambuzi.",
        editable_text_label: "Maandishi Yanayoweza Kuhaririwa",
        transcript_placeholder: "Maandishi ya manukuu...",
        about_matrix_analysis: "Kuhusu Uchambuzi wa Matrix",
        matrix_analysis_desc: "AI itachambua manukuu haya dhidi ya nyanja zote 19 za Matrix ya Kujitosheleza. Kila kikoa kitapokea alama kutoka 1-5 kulingana na ushahidi uliopatikana katika mazungumzo. Utaweza kupitia na kubadilisha alama zozote kabla ya kukamilisha.",
        analyzing_transcript_title: "Inachambua Manukuu...",
        analyzing_transcript_desc: "AI yetu inasoma kwa makini mazungumzo katika nyanja zote 19 za Matrix ya Kujitosheleza.",
        estimated_time: "Muda Unaokadiriwa",
        time_estimate: "Dakika 1-2",
        do_not_close: "Tafadhali usifunge dirisha hili au kuondoka.",
        save_before_analyzing: "Hifadhi mabadiliko kabla ya kuchambua",
        run_analysis_tooltip: "Endesha Uchambuzi"
    },
    // Tigrinya (ti)
    ti: {
        app_title: "SSA ኣፕሊኬሽን",
        dashboard_subtitle: "ዳሽቦርድ ምሕደራ ጉዳይ",
        new_assessment: "ሓድሽ ገምጋም",
        manage_case_workers: "ሰርሓተኛታት ጉዳይ ምምሕዳር",
        analytics: "ትንተና",
        total_case_workers: "ጠቕላላ ሰርሓተኛታት ጉዳይ",
        total_cases: "ጠቕላላ ጉዳያት",
        completed: "ተወዲኡ",
        active_users: "ንጡፋት ተጠቀምቲ",
        case_worker_activity: "ንጥፈታት ሰርሓተኛ ጉዳይ",
        recent_assessments: "ናይ ቀረባ ግዜ ገምጋማት",
        count_cases: "{count} ጉዳያት",
        loading_cases: "ጉዳያት ይጽዕን ኣሎ...",
        no_assessments: "ዛጊት ገምጋማት የለን",
        create_first: "ንምጅማር ናይ መጀመርታ ገምጋምካ ፍጠር",
        search_placeholder: "ብሽም ዓሚል ወይ መለለይ ድለ...",
        search_button: "ድለ",
        delete_assessment_title: "ገምጋም ደምሲስ?",
        delete_assessment_desc: "እዚ ስጉምቲ እዚ ክምለስ ኣይክእልን እዩ። እዚ ንገምጋም፣ ቀረጻታት፣ ትራንስክሪፕትን ነጥብታትን ንሓዋሩ ክድምስሶ እዩ።",
        cancel: "ሰርዝ",
        delete: "ደምሲስ",
        case_worker: "ሰርሓተኛ ጉዳይ",
        role: "ተራ",
        cases: "ጉዳያት",
        submitted: "ተላኢኹ",
        recordings: "ቀረጻታት",
        status_created: "ተፈጢሩ",
        status_audio_uploaded: "ድምጺ ድሉw",
        status_transcribed: "ተቀዲሑ",
        status_analyzed: "ተተንቲኑ",
        status_submitted: "ተላኢኹ",
        manage_case_worker_menu: "ምሕደራ ሰርሓተኛ ጉዳይ",
        ai_settings_menu: "AI ቅጥዕታት",
        sign_out: "ውፃእ",
        delete_assessment_tooltip: "ገምጋም ደምሲስ",
        assessment_deleted_toast: "ገምጋም ተደምሲሱ",
        failed_delete_assessment_toast: "ገምጋም ምድምሳስ ኣይተኻእለን",

        // Login
        login_subtitle: "ናብ ስርዓት ገምጋም ንምእታው ይእተዉ",
        email_label: "ኢመይል",
        email_placeholder: "ኢመይልኩም ኣእትዉ",
        password_label: "ፓስወርድ",
        password_placeholder: "ፓስወርድኩም ኣእትዉ",
        sign_in: "እተው",
        signing_in: "ይኣቱ ኣሎ...",
        enter_email_password: "በይዘኦም ኢመይልን ፓስወርድን የእትዉ",
        welcome: "መርሓባ",
        invalid_credentials: "ጌጋ መለለይ",

        // Case Detail
        dashboard_breadcrumb: "ዳሽቦርድ",
        case_information: "ሓበሬታ ጉዳይ",
        assessment_date: "ዕለት ገምጋም",
        next_step: "ዝቕጽል ስጉምቲ",
        view_transcript: "ትራንስክሪፕት ርኣይ",
        view_results: "ውጽኢት ርኣይ",
        view_full_results: "ምሉእ ውጽኢት ርኣይ",
        assessment_workflow: "መስርሕ ገምጋም",
        domain_scores_summary: "ጽማቕ ነጥብታት ዓውዲ",
        assessment_history: "ታሪኽ ገምጋም",
        track_progress: "ምዕባለ ኣብ ብዙሕ ገምጋማት ተኸታተል",
        current: "ሕዚ",
        view: "ርኣይ",
        quick_actions: "ቅልጡፍ ስጉምትታት",
        edit_case_details: "ዝርዝር ጉዳይ ኣርትዕ",
        save_changes_btn: "ለውጥታት ኣቅምጥ",
        saving: "ይቅምጥ ኣሎ...",
        export_pdf: "PDF ኣውጽእ",
        view_transcript_desc: "ዝተቀድሐ ዝርራብ ድገም",
        analyze_desc: "ትራንስክሪፕት ምስ ማትሪክስ ርእሰ-ምርኮሳ ኣተንትኖ",
        view_results_desc: "ነጥብታት ዓውዲ ድገምን ኣተኻክሎን",
        record_desc: "ዝርራብ ገምጋም ምቕራጽ ጀምር",
        success_case_updated: "ዝርዝር ጉዳይ ተሓዲሱ",
        error_update_case: "ዝርዝር ጉዳይ ምሕዳስ ኣይተኻእለን",
        transcript: "ትራንስክሪፕት",
        results: "ውጽኢት",

        // New Case
        new_assessment_title: "ሓድሽ ገምጋም",
        new_assessment_subtitle: "ንገምጋም ሓድሽ ጉዳይ ፍጠር",
        back: "ንድሕሪት",
        client_info_title: "ሓበሬታ ዓሚል",
        client_info_desc: "ገምጋም ንምጅማር ዝርዝር ዓሚል ኣእትዉ",
        client_name_label: "ሽም ዓሚል",
        client_id_label: "መለለይ ዓሚል",
        postal_code_label: "ፖስታ ኮድ",
        enter_name_placeholder: "ሽም ኣእትዉ",
        client_id_placeholder: "ንኣብነት CLT-001",
        postal_code_placeholder: "ንኣብነት 10001",
        client_id_help: "ባሕታዊ መለለይ ንእዚ ዓሚል (ንግላዊነት)",
        create_start_recording: "ፍጠርን ምቕራጽ ጀምርን",
        creating: "ይፈጥር ኣሎ...",
        error_client_name_required: "ሽም ዓሚል የድሊ",
        error_client_id_required: "መለለይ ዓሚል የድሊ",
        error_postal_code_required: "ፖስታ ኮድ የድሊ",
        success_case_created: "ጉዳይ ብዓወት ተፈጢሩ",
        error_create_case: "ጉዳይ ምፍጣር ኣይተኻእለን",

        // Recording
        record_conversation: "ዝርራብ ቅረጽ",
        microphone: "ማይክሮፎን",
        select_device: "መሳርሒ ምረጽ",
        consent: "ስምምዕ",
        consent_confirmation: "ስምምዕ ከም ዝተረኽበ የረጋግጽ።",
        recorder: "መቕረጺ",
        status_recording: "ይቀረጽ ኣሎ...",
        status_paused: "ጠጠው ኢሉ",
        status_saved: "ተቀሚጡ",
        status_ready: "ድሉw",
        click_to_start: "ንምጅማር ማይክሮፎን ጠውቕ",
        or: "ወይ",
        upload_audio: "ፋይል ድምጺ ጽዓን",
        upload_help: "MP3, WAV, M4A (ዝለዓለ 200MB)",
        preview: "ቅድመ-ርኣይ",
        discard: "ደርቢ",
        process_recording: "ምቕራጽ ኣሰናድእ",
        status_uploading: "ድምጺ ይጽዕን ኣሎ...",
        status_transcribing: "ይቅድሕ ኣሎ...",
        uploaded_recordings: "ዝተጻዕኑ ቀረጻታት",
        deselect_all: "ኩሉ ኣይትምረጽ",
        select_all: "ኩሉ ምረጽ",
        transcribe_selected: "ዝተመርጸ ቅዳሕ",
        save_recording_title: "ቀረጻ ኣቅምጥ",
        save_recording_desc: "ንእዚ ቀረጻ ደሓር ንምልላይ ዝሕግዝ ትርጉም ዘለዎ ሽም ሃቦ።",
        recording_name_label: "ሽም ቀረጻ",
        delete_recording_title: "ቀረጻ ደምሲስ?",
        delete_recording_desc: "ንእዚ ቀረጻ ንሓዋሩ ክትድምስሶ ከም እትደሊ ርግጸኛ ዲኻ? እዚ ስጉምቲ እዚ ክምለስ ኣይክእልን እዩ።",
        discard_recording_title: "ቀረጻ ደርቢ?",
        discard_recording_desc: "እዚ ንእዚ ዘይተቀመጠ ቀረጻ ከወግዶ እዩ። እዚ ስጉምቲ እዚ ክምለስ ኣይክእልን እዩ።",

        // Transcript
        review_edit_transcript: "ትራንስክሪፕት ድገምን ኣርትዕን",
        save_changes: "ለውጥታት ኣቅምጥ",
        run_analysis: "ትንተና ኣካይድ",
        run_matrix_analysis: "ትንተና ማትሪክስ ኣካይድ",
        analyzing_status: "ይትንትን ኣሎ...",
        no_transcript_title: "ዝርከብ ትራንስክሪፕት የለን",
        no_transcript_desc: "መጀመርታ ዝርራብ ቅረጽን ቅዳሕን",
        go_to_recording: "ናብ ቀረጻ ኪድ",
        edit_transcript_title: "ትራንስክሪፕት ኣርትዕ",
        edit_transcript_desc: "ትራንስክሪፕት ኣብ ታሕቲ ድገምን ኣርትዕን። ቅድሚ ትንተና ምክያድካ ዝኾነ ጌጋታት ኣዐሪ።",
        editable_text_label: "ዝእረም ጽሑፍ",
        transcript_placeholder: "ጽሑፍ ትራንስክሪፕት...",
        about_matrix_analysis: "ብዛዕባ ትንተና ማትሪክስ",
        matrix_analysis_desc: "AI ንእዚ ትራንስክሪፕት ምስ ኩሎም 19 ዓውድታት ማትሪክስ ርእሰ-ምርኮሳ ከተንትኖ እዩ። ነፍሲ ወከፍ ዓውዲ ኣብቲ ዝርራብ ብዝተረኽበ መርትዖ መሰረት ካብ 1-5 ነጥቢ ክረክብ እዩ። ቅድሚ ምውዳእካ ዝኾነ ነጥብታት ክትድግምን ክትቅይርን ክትክእል ኢኻ።",
        analyzing_transcript_title: "ትራንስክሪፕት ይትንትን ኣሎ...",
        analyzing_transcript_desc: "AI ናትና ንቲ ዝርራብ ብኩሎም 19 ዓውድታት ማትሪክስ ርእሰ-ምርኮሳ ብጥንቃቐ ይድግሞ ኣሎ።",
        estimated_time: "ዝግመት ግዜ",
        time_estimate: "1-2 ደቓይቕ",
        do_not_close: "በይዘኦም እዚ መስኮት ኣይትዓጽዉ ወይ ኣይትኪዱ።",
        save_before_analyzing: "ቅድሚ ምትንታን ለውጥታት ኣቅምጥ",
        run_analysis_tooltip: "ትንተና ኣካይድ"
    },
    // Farsi (fa)
    fa: {
        app_title: "برنامه SSA",
        dashboard_subtitle: "داشبورد مدیریت پرونده",
        new_assessment: "ارزیابی جدید",
        manage_case_workers: "مدیریت مددکاران پرونده",
        analytics: "تحلیل‌ها",
        total_case_workers: "مجموع مددکاران پرونده",
        total_cases: "مجموع پرونده‌ها",
        completed: "تکمیل شده",
        active_users: "کاربران فعال",
        case_worker_activity: "فعالیت مددکار پرونده",
        recent_assessments: "ارزیابی‌های اخیر",
        count_cases: "{count} پرونده",
        loading_cases: "در حال بارگیری پرونده‌ها...",
        no_assessments: "هنوز ارزیابی وجود ندارد",
        create_first: "برای شروع اولین ارزیابی خود را ایجاد کنید",
        search_placeholder: "جستجو بر اساس نام مشتری یا شناسه...",
        search_button: "جستجو",
        delete_assessment_title: "حذف ارزیابی؟",
        delete_assessment_desc: "این عمل قابل برگشت نیست. این کار ارزیابی، ضبط‌ها، متن و امتیازات را برای همیشه حذف می‌کند.",
        cancel: "لغو",
        delete: "حذف",
        case_worker: "مددکار پرونده",
        role: "نقش",
        cases: "پرونده‌ها",
        submitted: "ارسال شده",
        recordings: "ضبط‌ها",
        status_created: "ایجاد شده",
        status_audio_uploaded: "صوتی آماده",
        status_transcribed: "رونوشت شده",
        status_analyzed: "تحلیل شده",
        status_submitted: "ارسال شده",
        manage_case_worker_menu: "مدیریت مددکاران پرونده",
        ai_settings_menu: "تنظیمات هوش مصنوعی",
        sign_out: "خروج",
        delete_assessment_tooltip: "حذف ارزیابی",
        assessment_deleted_toast: "ارزیابی حذف شد",
        failed_delete_assessment_toast: "حذف ارزیابی ناموفق بود",

        // Login
        login_subtitle: "برای دسترسی به سیستم ارزیابی وارد شوید",
        email_label: "ایمیل",
        email_placeholder: "ایمیل خود را وارد کنید",
        password_label: "رمز عبور",
        password_placeholder: "رمز عبور خود را وارد کنید",
        sign_in: "ورود",
        signing_in: "در حال ورود...",
        enter_email_password: "لطفا ایمیل و رمز عبور را وارد کنید",
        welcome: "خوش آمدید",
        invalid_credentials: "اعتبار نامعتبر",

        // Case Detail
        dashboard_breadcrumb: "داشبورد",
        case_information: "اطلاعات پرونده",
        assessment_date: "تاریخ ارزیابی",
        next_step: "مرحله بعدی",
        view_transcript: "مشاهده متن",
        view_results: "مشاهده نتایج",
        view_full_results: "مشاهده نتایج کامل",
        assessment_workflow: "گردش کار ارزیابی",
        domain_scores_summary: "خلاصه امتیازات دامنه",
        assessment_history: "تاریخچه ارزیابی",
        track_progress: "پیگیری پیشرفت در ارزیابی‌های متعدد",
        current: "فعلی",
        view: "مشاهده",
        quick_actions: "اقدامات سریع",
        edit_case_details: "ویرایش جزئیات پرونده",
        save_changes_btn: "ذخیره تغییرات",
        saving: "در حال ذخیره...",
        export_pdf: "صادر کردن PDF",
        view_transcript_desc: "بررسی مکالمه رونوشت شده",
        analyze_desc: "تحلیل متن در برابر ماتریس خودکفایی",
        view_results_desc: "بررسی و تنظیم امتیازات دامنه",
        record_desc: "شروع ضبط مکالمه ارزیابی",
        success_case_updated: "جزئیات پرونده به‌روز شد",
        error_update_case: "به‌روزرسانی جزئیات پرونده ناموفق بود",
        transcript: "متن",
        results: "نتایج",

        // New Case
        new_assessment_title: "ارزیابی جدید",
        new_assessment_subtitle: "ایجاد پرونده جدید برای ارزیابی",
        back: "بازگشت",
        client_info_title: "اطلاعات مشتری",
        client_info_desc: "جزئیات مشتری را برای شروع ارزیابی وارد کنید",
        client_name_label: "نام مشتری",
        client_id_label: "شناسه مشتری",
        postal_code_label: "کد پستی",
        enter_name_placeholder: "نام را وارد کنید",
        client_id_placeholder: "مثلا CLT-001",
        postal_code_placeholder: "مثلا 10001",
        client_id_help: "شناسه منحصر به فرد برای این مشتری (برای حریم خصوصی)",
        create_start_recording: "ایجاد و شروع ضبط",
        creating: "در حال ایجاد...",
        error_client_name_required: "نام مشتری الزامی است",
        error_client_id_required: "شناسه مشتری الزامی است",
        error_postal_code_required: "کد پستی الزامی است",
        success_case_created: "پرونده با موفقیت ایجاد شد",
        error_create_case: "ایجاد پرونده ناموفق بود",

        // Recording
        record_conversation: "ضبط مکالمه",
        microphone: "میکروفون",
        select_device: "انتخاب دستگاه",
        consent: "رضایت",
        consent_confirmation: "تایید می‌کنم که رضایت گرفته شده است.",
        recorder: "ضبط کننده",
        status_recording: "در حال ضبط...",
        status_paused: "متوقف شده",
        status_saved: "ذخیره شده",
        status_ready: "آماده",
        click_to_start: "برای شروع میکروفون را کلیک کنید",
        or: "یا",
        upload_audio: "آپلود فایل صوتی",
        upload_help: "MP3, WAV, M4A (حداکثر 200 مگابایت)",
        preview: "پیش‌نمایش",
        discard: "دور انداختن",
        process_recording: "پردازش ضبط",
        status_uploading: "در حال آپلود صدا...",
        status_transcribing: "در حال رونوشت...",
        uploaded_recordings: "ضبط‌های آپلود شده",
        deselect_all: "لغو انتخاب همه",
        select_all: "انتخاب همه",
        transcribe_selected: "رونوشت انتخاب شده‌ها",
        save_recording_title: "ذخیره ضبط",
        save_recording_desc: "به این ضبط یک نام معنی‌دار بدهید تا بعدا بتوانید آن را شناسایی کنید.",
        recording_name_label: "نام ضبط",
        delete_recording_title: "حذف ضبط؟",
        delete_recording_desc: "آیا مطمئن هستید که می‌خواهید این ضبط را برای همیشه حذف کنید؟ این عمل قابل برگشت نیست.",
        discard_recording_title: "دور انداختن ضبط؟",
        discard_recording_desc: "این کار ضبط ذخیره نشده فعلی را حذف می‌کند. این عمل قابل برگشت نیست.",

        // Transcript
        review_edit_transcript: "بررسی و ویرایش متن",
        save_changes: "ذخیره تغییرات",
        run_analysis: "اجرای تحلیل",
        run_matrix_analysis: "اجرای تحلیل ماتریس",
        analyzing_status: "در حال تحلیل...",
        no_transcript_title: "متنی در دسترس نیست",
        no_transcript_desc: "ابتدا یک مکالمه را ضبط و رونوشت کنید",
        go_to_recording: "رفتن به ضبط",
        edit_transcript_title: "ویرایش متن",
        edit_transcript_desc: "متن زیر را بررسی و ویرایش کنید. هر گونه اشتباه را قبل از اجرای تحلیل اصلاح کنید.",
        editable_text_label: "متن قابل ویرایش",
        transcript_placeholder: "متن رونوشت...",
        about_matrix_analysis: "درباره تحلیل ماتریس",
        matrix_analysis_desc: "هوش مصنوعی این متن را در برابر تمام 19 دامنه ماتریس خودکفایی تحلیل خواهد کرد. هر دامنه بر اساس شواهد یافت شده در مکالمه امتیازی از 1 تا 5 دریافت خواهد کرد. شما می‌توانید قبل از نهایی کردن، هر امتیازی را بررسی و لغو کنید.",
        analyzing_transcript_title: "در حال تحلیل متن...",
        analyzing_transcript_desc: "هوش مصنوعی ما با دقت مکالمه را در تمام 19 دامنه ماتریس خودکفایی بررسی می‌کند.",
        estimated_time: "زمان تخمینی",
        time_estimate: "1-2 دقیقه",
        do_not_close: "لطفا این پنجره را نبندید یا از آن خارج نشوید.",
        save_before_analyzing: "ذخیره تغییرات قبل از تحلیل",
        run_analysis_tooltip: "اجرای تحلیل"
    },
    // Vietnamese (vi)
    vi: {
        app_title: "Ứng dụng SSA",
        dashboard_subtitle: "Bảng điều khiển quản lý hồ sơ",
        new_assessment: "Đánh giá mới",
        manage_case_workers: "Quản lý nhân viên xã hội",
        analytics: "Phân tích",
        total_case_workers: "Tổng số nhân viên xã hội",
        total_cases: "Tổng số hồ sơ",
        completed: "Đã hoàn thành",
        active_users: "Người dùng đang hoạt động",
        case_worker_activity: "Hoạt động của nhân viên xã hội",
        recent_assessments: "Đánh giá gần đây",
        count_cases: "{count} hồ sơ",
        loading_cases: "Đang tải hồ sơ...",
        no_assessments: "Chưa có đánh giá nào",
        create_first: "Tạo đánh giá đầu tiên để bắt đầu",
        search_placeholder: "Tìm kiếm theo tên khách hàng hoặc ID...",
        search_button: "Tìm kiếm",
        delete_assessment_title: "Xóa đánh giá?",
        delete_assessment_desc: "Hành động này không thể hoàn tác. Việc này sẽ xóa vĩnh viễn đánh giá, bản ghi âm, bảng điểm và điểm số.",
        cancel: "Hủy",
        delete: "Xóa",
        case_worker: "Nhân viên xã hội",
        role: "Vai trò",
        cases: "Hồ sơ",
        submitted: "Đã gửi",
        recordings: "Bản ghi âm",
        status_created: "Đã tạo",
        status_audio_uploaded: "Âm thanh đã sẵn sàng",
        status_transcribed: "Đã chép lời",
        status_analyzed: "Đã phân tích",
        status_submitted: "Đã gửi",
        manage_case_worker_menu: "Quản lý nhân viên xã hội",
        ai_settings_menu: "Cài đặt AI",
        sign_out: "Đăng xuất",
        delete_assessment_tooltip: "Xóa đánh giá",
        assessment_deleted_toast: "Đánh giá đã bị xóa",
        failed_delete_assessment_toast: "Không thể xóa đánh giá",

        // Login
        login_subtitle: "Đăng nhập để truy cập hệ thống đánh giá",
        email_label: "Email",
        email_placeholder: "Nhập email của bạn",
        password_label: "Mật khẩu",
        password_placeholder: "Nhập mật khẩu của bạn",
        sign_in: "Đăng nhập",
        signing_in: "Đang đăng nhập...",
        enter_email_password: "Vui lòng nhập email và mật khẩu",
        welcome: "Chào mừng",
        invalid_credentials: "Thông tin đăng nhập không hợp lệ",

        // Case Detail
        dashboard_breadcrumb: "Bảng điều khiển",
        case_information: "Thông tin hồ sơ",
        assessment_date: "Ngày đánh giá",
        next_step: "Bước tiếp theo",
        view_transcript: "Xem bảng điểm",
        view_results: "Xem kết quả",
        view_full_results: "Xem kết quả đầy đủ",
        assessment_workflow: "Quy trình đánh giá",
        domain_scores_summary: "Tóm tắt điểm số lĩnh vực",
        assessment_history: "Lịch sử đánh giá",
        track_progress: "Theo dõi tiến độ qua nhiều đánh giá",
        current: "Hiện tại",
        view: "Xem",
        quick_actions: "Hành động nhanh",
        edit_case_details: "Chỉnh sửa chi tiết hồ sơ",
        save_changes_btn: "Lưu thay đổi",
        saving: "Đang lưu...",
        export_pdf: "Xuất PDF",
        view_transcript_desc: "Xem lại cuộc hội thoại đã chép lời",
        analyze_desc: "Phân tích bảng điểm dựa trên Ma trận Tự cung tự cấp",
        view_results_desc: "Xem lại và điều chỉnh điểm số lĩnh vực",
        record_desc: "Bắt đầu ghi âm cuộc hội thoại đánh giá",
        success_case_updated: "Chi tiết hồ sơ đã được cập nhật",
        error_update_case: "Không thể cập nhật chi tiết hồ sơ",
        transcript: "Bảng điểm",
        results: "Kết quả",

        // New Case
        new_assessment_title: "Đánh giá mới",
        new_assessment_subtitle: "Tạo hồ sơ mới để đánh giá",
        back: "Quay lại",
        client_info_title: "Thông tin khách hàng",
        client_info_desc: "Nhập chi tiết khách hàng để bắt đầu đánh giá",
        client_name_label: "Tên khách hàng",
        client_id_label: "ID khách hàng",
        postal_code_label: "Mã bưu chính",
        enter_name_placeholder: "Nhập tên",
        client_id_placeholder: "ví dụ: CLT-001",
        postal_code_placeholder: "ví dụ: 10001",
        client_id_help: "Mã định danh duy nhất cho khách hàng này (để bảo mật)",
        create_start_recording: "Tạo & Bắt đầu ghi âm",
        creating: "Đang tạo...",
        error_client_name_required: "Tên khách hàng là bắt buộc",
        error_client_id_required: "ID khách hàng là bắt buộc",
        error_postal_code_required: "Mã bưu chính là bắt buộc",
        success_case_created: "Hồ sơ được tạo thành công",
        error_create_case: "Không thể tạo hồ sơ",

        // Recording
        record_conversation: "Ghi âm cuộc hội thoại",
        microphone: "Micrô",
        select_device: "Chọn thiết bị",
        consent: "Đồng ý",
        consent_confirmation: "Tôi xác nhận rằng đã có sự đồng ý.",
        recorder: "Máy ghi âm",
        status_recording: "Đang ghi âm...",
        status_paused: "Đã tạm dừng",
        status_saved: "Đã lưu",
        status_ready: "Sẵn sàng",
        click_to_start: "Nhấp vào micrô để bắt đầu",
        or: "HOẶC",
        upload_audio: "Tải lên tệp âm thanh",
        upload_help: "MP3, WAV, M4A (Tối đa 200MB)",
        preview: "Xem trước",
        discard: "Hủy bỏ",
        process_recording: "Xử lý bản ghi âm",
        status_uploading: "Đang tải lên âm thanh...",
        status_transcribing: "Đang chép lời...",
        uploaded_recordings: "Bản ghi âm đã tải lên",
        deselect_all: "Bỏ chọn tất cả",
        select_all: "Chọn tất cả",
        transcribe_selected: "Chép lời đã chọn",
        save_recording_title: "Lưu bản ghi âm",
        save_recording_desc: "Đặt tên có ý nghĩa cho bản ghi âm này để giúp bạn nhận ra sau này.",
        recording_name_label: "Tên bản ghi âm",
        delete_recording_title: "Xóa bản ghi âm?",
        delete_recording_desc: "Bạn có chắc chắn muốn xóa vĩnh viễn bản ghi âm này không? Hành động này không thể hoàn tác.",
        discard_recording_title: "Hủy bỏ bản ghi âm?",
        discard_recording_desc: "Việc này sẽ xóa bản ghi âm chưa lưu hiện tại. Hành động này không thể hoàn tác.",

        // Transcript
        review_edit_transcript: "Xem lại & Chỉnh sửa Bảng điểm",
        save_changes: "Lưu thay đổi",
        run_analysis: "Chạy phân tích",
        run_matrix_analysis: "Chạy phân tích ma trận",
        analyzing_status: "Đang phân tích...",
        no_transcript_title: "Không có bảng điểm",
        no_transcript_desc: "Ghi âm và chép lời cuộc hội thoại trước",
        go_to_recording: "Đi đến bản ghi âm",
        edit_transcript_title: "Chỉnh sửa bảng điểm",
        edit_transcript_desc: "Xem lại và chỉnh sửa bảng điểm bên dưới. Sửa bất kỳ lỗi nào trước khi chạy phân tích.",
        editable_text_label: "Văn bản có thể chỉnh sửa",
        transcript_placeholder: "Văn bản bảng điểm...",
        about_matrix_analysis: "Về Phân tích Ma trận",
        matrix_analysis_desc: "AI sẽ phân tích bảng điểm này dựa trên tất cả 19 lĩnh vực của Ma trận Tự cung tự cấp. Mỗi lĩnh vực sẽ nhận được điểm từ 1-5 dựa trên bằng chứng tìm thấy trong cuộc hội thoại. Bạn sẽ có thể xem lại và ghi đè bất kỳ điểm số nào trước khi hoàn tất.",
        analyzing_transcript_title: "Đang phân tích bảng điểm...",
        analyzing_transcript_desc: "AI của chúng tôi đang xem xét cẩn thận cuộc hội thoại qua tất cả 19 lĩnh vực của Ma trận Tự cung tự cấp.",
        estimated_time: "Thời gian ước tính",
        time_estimate: "1-2 phút",
        do_not_close: "Vui lòng không đóng cửa sổ này hoặc điều hướng đi nơi khác.",
        save_before_analyzing: "Lưu thay đổi trước khi phân tích",
        run_analysis_tooltip: "Chạy phân tích"
    },
    // Urdu (ur)
    ur: {
        app_title: "SSA درخواست",
        dashboard_subtitle: "کیس مینجمنٹ ڈیش بورڈ",
        new_assessment: "نیا تخمینہ",
        manage_case_workers: "کیس ورکرز کا انتظام",
        analytics: "تجزیات",
        total_case_workers: "کل کیس ورکرز",
        total_cases: "کل کیسز",
        completed: "مکمل",
        active_users: "فعال صارفین",
        case_worker_activity: "کیس ورکر کی سرگرمی",
        recent_assessments: "حالیہ تخمینے",
        count_cases: "{count} کیسز",
        loading_cases: "کیسز لوڈ ہو رہے ہیں...",
        no_assessments: "ابھی تک کوئی تخمینہ نہیں",
        create_first: "شروع کرنے کے لیے اپنا پہلا تخمینہ بنائیں",
        search_placeholder: "کلائنٹ کا نام یا ID کے ذریعہ تلاش کریں...",
        search_button: "تلاش کریں",
        delete_assessment_title: "تخمینہ حذف کریں؟",
        delete_assessment_desc: "اس عمل کو واپس نہیں کیا جا سکتا۔ یہ تخمینہ، ریکارڈنگز، ٹرانسکرپٹ اور اسکورز کو مستقل طور پر حذف کر دے گا۔",
        cancel: "منسوخ کریں",
        delete: "حذف کریں",
        case_worker: "کیس ورکر",
        role: "کردار",
        cases: "کیسز",
        submitted: "جمع کرایا گیا",
        recordings: "ریکارڈنگز",
        status_created: "بنایا گیا",
        status_audio_uploaded: "آڈیو تیار",
        status_transcribed: "نوٹ کیا گیا",
        status_analyzed: "تجزیہ کیا گیا",
        status_submitted: "جمع کرایا گیا",
        manage_case_worker_menu: "کیس ورکر مینجمنٹ",
        ai_settings_menu: "AI ترتیبات",
        sign_out: "سائن آؤٹ",
        delete_assessment_tooltip: "تخمینہ حذف کریں",
        assessment_deleted_toast: "تخمینہ حذف کر دیا گیا",
        failed_delete_assessment_toast: "تخمینہ حذف کرنے میں ناکام",

        // Login
        login_subtitle: "تخمینہ کے نظام تک رسائی کے لیے سائن ان کریں",
        email_label: "ای میل",
        email_placeholder: "اپنی ای میل درج کریں",
        password_label: "پاس ورڈ",
        password_placeholder: "اپنا پاس ورڈ درج کریں",
        sign_in: "سائن ان کریں",
        signing_in: "سائن ان ہو رہا ہے...",
        enter_email_password: "براہ کرم ای میل اور پاس ورڈ درج کریں",
        welcome: "خوش آمدید",
        invalid_credentials: "غلط اسناد",

        // Case Detail
        dashboard_breadcrumb: "ڈیش بورڈ",
        case_information: "کیس کی معلومات",
        assessment_date: "تخمینہ کی تاریخ",
        next_step: "اگلا مرحلہ",
        view_transcript: "ٹرانسکرپٹ دیکھیں",
        view_results: "نتائج دیکھیں",
        view_full_results: "مکمل نتائج دیکھیں",
        assessment_workflow: "تخمینہ کا ورک فلو",
        domain_scores_summary: "ڈومین اسکورز کا خلاصہ",
        assessment_history: "تخمینہ کی تاریخ",
        track_progress: "متعدد تخمینوں میں پیشرفت کو ٹریک کریں",
        current: "موجودہ",
        view: "دیکھیں",
        quick_actions: "فوری اقدامات",
        edit_case_details: "کیس کی تفصیلات میں ترمیم کریں",
        save_changes_btn: "تبدیلیاں محفوظ کریں",
        saving: "محفوظ ہو رہا ہے...",
        export_pdf: "PDF برآمد کریں",
        view_transcript_desc: "نوٹ کی گئی گفتگو کا جائزہ لیں",
        analyze_desc: "خود انحصاری میٹرکس کے خلاف ٹرانسکرپٹ کا تجزیہ کریں",
        view_results_desc: "ڈومین اسکورز کا جائزہ لیں اور ایڈجسٹ کریں",
        record_desc: "تخمینہ کی گفتگو ریکارڈ کرنا شروع کریں",
        success_case_updated: "کیس کی تفصیلات کو اپ ڈیٹ کر دیا گیا",
        error_update_case: "کیس کی تفصیلات کو اپ ڈیٹ کرنے میں ناکام",
        transcript: "ٹرانسکرپٹ",
        results: "نتائج",

        // New Case
        new_assessment_title: "نیا تخمینہ",
        new_assessment_subtitle: "تخمینہ کے لیے نیا کیس بنائیں",
        back: "واپس",
        client_info_title: "کلائنٹ کی معلومات",
        client_info_desc: "تخمینہ شروع کرنے کے لیے کلائنٹ کی تفصیلات درج کریں",
        client_name_label: "کلائنٹ کا نام",
        client_id_label: "کلائنٹ ID",
        postal_code_label: "پوسٹل کوڈ",
        enter_name_placeholder: "نام درج کریں",
        client_id_placeholder: "مثال CLT-001",
        postal_code_placeholder: "مثال 10001",
        client_id_help: "اس کلائنٹ کے لیے منفرد شناخت کنندہ (رازداری کے لیے)",
        create_start_recording: "بنائیں اور ریکارڈنگ شروع کریں",
        creating: "بن رہا ہے...",
        error_client_name_required: "کلائنٹ کا نام درکار ہے",
        error_client_id_required: "کلائنٹ ID درکار ہے",
        error_postal_code_required: "پوسٹل کوڈ درکار ہے",
        success_case_created: "کیس کامیابی کے ساتھ بنایا گیا",
        error_create_case: "کیس بنانے میں ناکام",

        // Recording
        record_conversation: "گفتگو ریکارڈ کریں",
        microphone: "مائیکروفون",
        select_device: "آلہ منتخب کریں",
        consent: "رضامندی",
        consent_confirmation: "میں تصدیق کرتا ہوں کہ رضامندی حاصل کر لی گئی ہے۔",
        recorder: "ریکارڈر",
        status_recording: "ریکارڈنگ ہو رہی ہے...",
        status_paused: "روکا گیا",
        status_saved: "محفوظ",
        status_ready: "تیار",
        click_to_start: "شروع کرنے کے لیے مائیکروفون پر کلک کریں",
        or: "یا",
        upload_audio: "آڈیو فائل اپ لوڈ کریں",
        upload_help: "MP3, WAV, M4A (زیادہ سے زیادہ 200MB)",
        preview: "پیش نظارہ",
        discard: "رد کریں",
        process_recording: "ریکارڈنگ پر عمل کریں",
        status_uploading: "آڈیو اپ لوڈ ہو رہا ہے...",
        status_transcribing: "نوٹ کیا جا رہا ہے...",
        uploaded_recordings: "اپ لوڈ کردہ ریکارڈنگز",
        deselect_all: "سب کو غیر منتخب کریں",
        select_all: "سب کو منتخب کریں",
        transcribe_selected: "منتخب کردہ کو نوٹ کریں",
        save_recording_title: "ریکارڈنگ محفوظ کریں",
        save_recording_desc: "اس ریکارڈنگ کو ایک بامعنی نام دیں تاکہ آپ کو بعد میں اس کی شناخت کرنے میں مدد ملے۔",
        recording_name_label: "ریکارڈنگ کا نام",
        delete_recording_title: "ریکارڈنگ حذف کریں؟",
        delete_recording_desc: "کیا آپ واقعی اس ریکارڈنگ کو مستقل طور پر حذف کرنا چاہتے ہیں؟ اس عمل کو واپس نہیں کیا جا سکتا۔",
        discard_recording_title: "ریکارڈنگ رد کریں؟",
        discard_recording_desc: "یہ موجودہ غیر محفوظ شدہ ریکارڈنگ کو ہٹا دے گا۔ اس عمل کو واپس نہیں کیا جا سکتا۔",

        // Transcript
        review_edit_transcript: "ٹرانسکرپٹ کا جائزہ لیں اور ترمیم کریں",
        save_changes: "تبدیلیاں محفوظ کریں",
        run_analysis: "تجزیہ چلائیں",
        run_matrix_analysis: "میٹرکس تجزیہ چلائیں",
        analyzing_status: "تجزیہ ہو رہا ہے...",
        no_transcript_title: "کوئی ٹرانسکرپٹ دستیاب نہیں",
        no_transcript_desc: "پہلے گفتگو ریکارڈ کریں اور نوٹ کریں",
        go_to_recording: "ریکارڈنگ پر جائیں",
        edit_transcript_title: "ٹرانسکرپٹ میں ترمیم کریں",
        edit_transcript_desc: "نیچے ٹرانسکرپٹ کا جائزہ لیں اور ترمیم کریں۔ تجزیہ چلانے سے پہلے کسی بھی غلطی کو درست کریں۔",
        editable_text_label: "قابل ترمیم متن",
        transcript_placeholder: "ٹرانسکرپٹ متن...",
        about_matrix_analysis: "میٹرکس تجزیہ کے بارے میں",
        matrix_analysis_desc: "AI اس ٹرانسکرپٹ کا خود انحصاری میٹرکس کے تمام 19 ڈومینز کے خلاف تجزیہ کرے گا۔ گفتگو میں پائے جانے والے شواہد کی بنیاد پر ہر ڈومین کو 1-5 کا اسکور ملے گا۔ آپ حتمی شکل دینے سے پہلے کسی بھی اسکور کا جائزہ لے سکیں گے اور اسے تبدیل کر سکیں گے۔",
        analyzing_transcript_title: "ٹرانسکرپٹ کا تجزیہ ہو رہا ہے...",
        analyzing_transcript_desc: "ہمارا AI خود انحصاری میٹرکس کے تمام 19 ڈومینز میں گفتگو کا بغور جائزہ لے رہا ہے۔",
        estimated_time: "تخمینی وقت",
        time_estimate: "1-2 منٹ",
        do_not_close: "براہ کرم اس ونڈو کو بند نہ کریں یا یہاں سے نہ جائیں۔",
        save_before_analyzing: "تجزیہ کرنے سے پہلے تبدیلیاں محفوظ کریں",
        run_analysis_tooltip: "تجزیہ چلائیں"
    },
    // Turkish (tr)
    tr: {
        app_title: "SSA Uygulaması",
        dashboard_subtitle: "Vaka Yönetim Paneli",
        new_assessment: "Yeni Değerlendirme",

        // Login
        login_subtitle: "Değerlendirme sistemine erişmek için giriş yapın",
        email_label: "E-posta",
        email_placeholder: "E-postanızı girin",
        password_label: "Şifre",
        password_placeholder: "Şifrenizi girin",
        sign_in: "Giriş Yap",
        signing_in: "Giriş yapılıyor...",
        enter_email_password: "Lütfen e-posta ve şifrenizi girin",
        welcome: "Hoş geldiniz",
        invalid_credentials: "Geçersiz kimlik bilgileri",

        manage_case_workers: "Vaka Çalışanlarını Yönet",
        analytics: "Analitik",
        total_case_workers: "Toplam Vaka Çalışanları",
        total_cases: "Toplam Vakalar",
        completed: "Tamamlandı",
        active_users: "Aktif Kullanıcılar",
        case_worker_activity: "Vaka Çalışanı Aktivitesi",
        recent_assessments: "Son Değerlendirmeler",
        count_cases: "{count} olay",
        loading_cases: "Vakalar yükleniyor...",
        no_assessments: "Henüz değerlendirme yok",
        create_first: "Başlamak için ilk değerlendirmenizi oluşturun",
        search_placeholder: "Müşteri adı veya kimliğine göre ara...",
        search_button: "Ara",
        delete_assessment_title: "Değerlendirmeyi Sil?",
        delete_assessment_desc: "Bu işlem geri alınamaz. Bu, değerlendirmeyi, kayıtları, transkripti ve puanları kalıcı olarak siler.",
        cancel: "İptal",
        delete: "Sil",
        case_worker: "Vaka Çalışanı",
        role: "Rol",
        cases: "Vakalar",
        submitted: "Gönderildi",
        recordings: "Kayıtlar",
        status_created: "Oluşturuldu",
        status_audio_uploaded: "Ses Hazır",
        status_transcribed: "Transkribe Edildi",
        status_analyzed: "Analiz Edildi",
        status_submitted: "Gönderildi",
        manage_case_worker_menu: "Vaka Çalışanı Yönetimi",
        ai_settings_menu: "YZ Ayarları",
        sign_out: "Çıkış Yap",
        delete_assessment_tooltip: "Değerlendirmeyi Sil",
        assessment_deleted_toast: "Değerlendirme silindi",
        failed_delete_assessment_toast: "Değerlendirme silinemedi",

        // Case Detail
        dashboard_breadcrumb: "Panel",
        case_information: "Vaka Bilgisi",
        assessment_date: "Değerlendirme Tarihi",
        next_step: "Sonraki Adım",
        view_transcript: "Transkripti Görüntüle",
        view_results: "Sonuçları Görüntüle",
        view_full_results: "Tam Sonuçları Görüntüle",
        assessment_workflow: "Değerlendirme İş Akışı",
        domain_scores_summary: "Alan Puan Özeti",
        assessment_history: "Değerlendirme Geçmişi",
        track_progress: "Birden fazla değerlendirmede ilerlemeyi takip et",
        current: "Mevcut",
        view: "Görüntüle",
        quick_actions: "Hızlı İşlemler",
        edit_case_details: "Vaka Detaylarını Düzenle",
        save_changes_btn: "Değişiklikleri Kaydet",
        saving: "Kaydediliyor...",
        export_pdf: "PDF Dışa Aktar",
        view_transcript_desc: "Transkribe edilen görüşmeyi incele",
        analyze_desc: "Transkripti Öz Yeterlilik Matrisi'ne göre analiz et",
        view_results_desc: "Alan puanlarını incele ve ayarla",
        record_desc: "Değerlendirme görüşmesini kaydetmeye başla",
        success_case_updated: "Vaka detayları güncellendi",
        error_update_case: "Vaka detayları güncellenemedi",
        transcript: "Transkript",
        results: "Sonuçlar",


        // New Case
        new_assessment_title: "Yeni Değerlendirme",
        new_assessment_subtitle: "Değerlendirme için yeni bir vaka oluştur",
        back: "Geri",
        client_info_title: "Müşteri Bilgisi",
        client_info_desc: "Değerlendirmeye başlamak için müşteri detaylarını girin",
        client_name_label: "Müşteri Adı",
        client_id_label: "Müşteri Kimliği",
        postal_code_label: "Posta Kodu",
        enter_name_placeholder: "İsim girin",
        client_id_placeholder: "örn. CLT-001",
        postal_code_placeholder: "örn. 10001",
        client_id_help: "Bu müşteri için benzersiz tanımlayıcı (gizlilik için)",
        create_start_recording: "Oluştur ve Kaydetmeye Başla",
        creating: "Oluşturuluyor...",
        error_client_name_required: "Müşteri adı gereklidir",
        error_client_id_required: "Müşteri kimliği gereklidir",
        error_postal_code_required: "Posta Kodu gereklidir",
        success_case_created: "Vaka başarıyla oluşturuldu",
        error_create_case: "Vaka oluşturulamadı",

        // Recording
        record_conversation: "Görüşmeyi Kaydet",
        microphone: "Mikrofon",
        select_device: "Cihaz seç",
        consent: "Onay",
        consent_confirmation: "Onayın alındığını onaylıyorum.",
        recorder: "Kaydedici",
        status_recording: "Kaydediliyor...",
        status_paused: "Duraklatıldı",
        status_saved: "Kaydedildi",
        status_ready: "Hazır",
        click_to_start: "Başlamak için mikrofona tıklayın",
        or: "VEYA",
        upload_audio: "Ses Dosyası Yükle",
        upload_help: "MP3, WAV, M4A (Maks 200MB)",
        preview: "Önizleme",
        discard: "Vazgeç",
        process_recording: "Kaydı İşle",
        status_uploading: "Ses yükleniyor...",
        status_transcribing: "Transkribe ediliyor...",
        uploaded_recordings: "Yüklenen Kayıtlar",
        deselect_all: "Tümünü Kaldır",
        select_all: "Tümünü Seç",
        transcribe_selected: "Seçilenleri Transkribe Et",
        save_recording_title: "Kaydı Kaydet",
        save_recording_desc: "Daha sonra tanımlayabilmek için bu kayda anlamlı bir isim verin.",
        recording_name_label: "Kayıt Adı",
        delete_recording_title: "Kaydı Sil?",
        delete_recording_desc: "Bu kaydı kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        discard_recording_title: "Kaydı Vazgeç?",
        discard_recording_desc: "Bu, mevcut kaydedilmemiş kaydı kaldıracaktır. Bu işlem geri alınamaz.",

        // Transcript
        review_edit_transcript: "Transkripti İncele ve Düzenle",
        save_changes: "Değişiklikleri Kaydet",
        run_analysis: "Analizi Çalıştır",
        run_matrix_analysis: "Matris Analizini Çalıştır",
        analyzing_status: "Analiz ediliyor...",
        no_transcript_title: "Transkript mevcut değil",
        no_transcript_desc: "Önce bir görüşme kaydedin ve transkribe edin",
        go_to_recording: "Kayda Git",
        edit_transcript_title: "Transkripti Düzenle",
        edit_transcript_desc: "Aşağıdaki transkripti inceleyin ve düzenleyin. Analizi çalıştırmadan önce hataları düzeltin.",
        editable_text_label: "Düzenlenebilir Metin",
        transcript_placeholder: "Transkript metni...",
        about_matrix_analysis: "Matris Analizi Hakkında",
        matrix_analysis_desc: "YZ, bu transkripti Öz Yeterlilik Matrisi'nin 19 alanına göre analiz edecektir. Her alan, görüşmede bulunan kanıtlara dayanarak 1-5 arasında bir puan alacaktır. Kesinleştirmeden önce puanları inceleyebilir ve geçersiz kılabilirsiniz.",
        analyzing_transcript_title: "Transkript Analiz Ediliyor...",
        analyzing_transcript_desc: "Yapay zekamız, görüşmeyi Öz Yeterlilik Matrisi'nin tüm 19 alanı boyunca dikkatlice inceliyor.",
        estimated_time: "Tahmini Süre",
        time_estimate: "1-2 dakika",
        do_not_close: "Lütfen bu pencereyi kapatmayın veya ayrılmayın.",
        save_before_analyzing: "Analizden önce değişiklikleri kaydet",
        run_analysis_tooltip: "Analizi Çalıştır",
        analysis_config_title: "Analiz Yapılandırması",
        analysis_config_desc: "YZ analizi ve rapor oluşturma için hedef dili seçin.",
        target_language_label: "Hedef Dil",
        select_language_placeholder: "Hedef dili seçin",
        language_analysis_note: "YZ, puanlama gerekçelerini ve tam vaka raporunu seçilen dilde oluşturacaktır.",
        start_analysis_btn: "Analizi Başlat",
        error_load_transcript: "Transkript yüklenemedi",
        success_transcript_updated: "Transkript güncellendi",
        error_save_transcript: "Transkript kaydedilemedi",
        success_analysis_complete: "Analiz tamamlandı",
        error_analysis_failed: "Analiz başarısız",
        needs_review: "İnceleme Gerekiyor",
        reviewed: "İncelendi",
        goal_label: "Hedef",
        ai_score_label: "YZ Puanı",
        confidence_label: "Güven",
        final_score_label: "Final",
        ai_justification_title: "YZ Gerekçesi",
        no_justification: "Gerekçe belirtilmedi.",
        evidence_quotes_title: "Kanıt Alıntıları",
        no_evidence: "Kanıt alıntısı bulunamadı.",
        show_score_definitions: "Puan Tanımlarını Göster",
        review_adjust_title: "İncele ve Ayarla",
        final_score_range_label: "Final Puanı (0-5)",
        select_score_placeholder: "Puan seçin",
        score_0_desc: "0 - N/A veya Yetersiz Bilgi",
        score_1_desc: "1 - Krizde",
        score_2_desc: "2 - Savunmasız",
        score_3_desc: "3 - Güvende",
        score_4_desc: "4 - Kapasite Geliştiriyor",
        score_5_desc: "5 - Gelişiyor",
        mark_as_goal: "Katılımcı hedefi olarak işaretle",
        notes_label: "Notlar",
        add_notes_placeholder: "Değerlendirme notları ekleyin...",
        confirm_save: "Onayla ve Kaydet",
        assessment_submitted_locked: "Değerlendirme gönderildi. Düzenlemeler kilitlendi.",
        loading_report: "Rapor yükleniyor...",
        no_report_generated_title: "Rapor Oluşturulmadı",
        no_report_generated_desc: "Öznel, Nesnel, Değerlendirme, Plan (SOAP), Temel Güçlü Yönler ve Eylem Planı içeren kapsamlı bir vaka raporu oluşturun.",
        generating_report: "YZ Raporu Oluşturuluyor...",
        generate_report_btn: "Rapor Oluştur",
        generated_on: "Oluşturulma tarihi",
        at_time: "saat",
        edit_report_btn: "Raporu Düzenle",
        download_pdf_btn: "PDF İndir",
        revert_to_original: "Orijinale Dön",
        loading: "Yükleniyor...",
        case_not_found: "Vaka bulunamadı",
        describe_inconsistency: "Tutarsızlığı tanımlayın...",
        no_summary: "Özet içeriği yok.",
        subjective_title: "1. Öznel",
        subjective_subtitle: "Müşterinin belirttiği ihtiyaçlar ve bakış açısı.",
        subjective_placeholder: "Öznel bulguları girin...",
        no_subjective: "Öznel içerik yok.",
        objective_title: "2. Nesnel",
        objective_subtitle: "Gözlemlenebilir gerçekler ve değerlendirme puanları.",
        objective_placeholder: "Nesnel bulguları girin...",
        no_objective: "Nesnel içerik yok.",
        assessment_title: "3. Değerlendirme",
        assessment_subtitle: "Durumun profesyonel analizi.",
        assessment_placeholder: "Değerlendirme analizini girin...",
        no_assessment: "Değerlendirme içeriği yok.",
        plan_title: "4. Plan",
        plan_subtitle: "Sonraki adımlar ve öneriler.",
        plan_placeholder: "Planı girin...",
        no_plan: "Plan içeriği yok.",
        key_strengths_title: "Temel Güçlü Yönler",
        no_strengths: "Belirlenmiş temel güçlü yön yok.",
        add_strength_btn: "Güçlü Yön Ekle",
        action_plan_title: "Eylem Planı Hedefleri",
        domain_label: "Alan",
        remove_btn: "Kaldır",
        domain_placeholder: "Alan (örn. Konut)",
        goal_placeholder: "Özel hedef...",
        no_action_plan: "Eylem planı öğesi yok.",
        add_action_goal_btn: "Eylem Hedefi Ekle",
        assessment_scores_tab: "Değerlendirme Puanları",
        case_report_tab: "Vaka Raporu",
        require_review_msg: "alan(lar) inceleme gerektiriyor. Göndermeden önce puanı onaylamalı veya ayarlamalısınız.",
        total_score_label: "Toplam Puan",
        pending_review_label: "İnceleme Bekliyor",
        goals_set_label: "Belirlenen Hedefler",
        domain_scores_title: "Alan Puanları",
        assessment_locked_msg: "Değerlendirme kilitlendi.",
        review_ai_scores_desc: "YZ tarafından oluşturulan puanları inceleyin ve ayarlamalar yapın.",
        submit_assessment_title: "Değerlendirmeyi Gönder?",
        submit_assessment_desc: "Gönderildikten sonra bu değerlendirme kilitlenecek ve normal kullanıcılar tarafından düzenlenemeyecektir. Devam etmek istediğinizden emin misiniz?",
        submitting: "Gönderiliyor...",
        submit_confirm_btn: "Evet, Gönder",
        status_submitted: "Gönderildi",
        domain_housing: "Barınma",
        domain_employment: "İstihdam",
        domain_income: "Gelir",
        domain_food: "Gıda",
        domain_child_care: "Çocuk Bakımı",
        domain_childrens_education: "Çocuk Eğitimi",
        domain_adult_education: "Yetişkin Eğitimi",
        domain_health_care_coverage: "Sağlık Sigortası",
        domain_life_skills: "Yaşam Becerileri",
        domain_family_social_relations: "Aile/Sosyal İlişkiler",
        domain_mobility: "Hareketlilik",
        domain_community_involvement: "Toplumsal Katılım",
        domain_parenting_skills: "Ebeveynlik Becerileri",
        domain_legal: "Yasal",
        domain_mental_health: "Ruh Sağlığı",
        domain_substance_abuse: "Madde Bağımlılığı",
        domain_safety: "Güvenlik",
        domain_disabilities: "Engellilik",
        domain_other_optional: "Diğer (İsteğe Bağlı)"
    }
};

// Helper: Populate missing keys from English for all languages
const supportedCodes = [
    "ht", "so", "ru", "sw", "ti", "fa", "vi", "ur", "tr",
    "ar-ma", "ar-qa", "ar-lb", "ar-sy"
];

// We manually spread english into the languages that are partial
supportedCodes.forEach(code => {
    // If the language object doesn't exist, create it from English
    if (!translations[code]) {
        translations[code] = { ...translations['en'] };
    } else {
        // If it exists but might miss keys, merge English keys into it
        // This ensures that any key missing in 'ht' (e.g. 'delete') falls back to 'en' 'Delete'
        // instead of being undefined.
        translations[code] = { ...translations['en'], ...translations[code] };
    }

    // Arabic dialects fallback to 'ar' then 'en'
    if (code.startsWith('ar-') && translations['ar']) {
        translations[code] = { ...translations['ar'], ...translations[code] };
    }
});

export const getTranslation = (langCode, key) => {
    const lang = translations[langCode] || translations['en'];
    return lang[key] || translations['en'][key] || key;
};
